import React, { useEffect, useState, useCallback, useRef } from "react";
import MelhorarSkills from "../components/MelhorarSkills";
import CandidaturaEmLote from "../components/CandidaturaEmLote";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import { useAuth } from "../context/AuthContext";
import CompartilharVaga from "../components/CompartilharVaga";
import { MOTIVOS_NAO_CONSEGUIU, baixarCurriculoGerado } from "../services/api";
import { estadoEntrega, minhaIntencao, obterMeuPerfil, salvarPerfil, obterVaga, obterVagaPorSlug, obterEmpresa, obterPerfilPublico, candidatosDaVaga, darRetornoVaga, candidatarVaga, interesseNaVaga, alterarStatusVaga, candidaturasDaVaga, registrarRetornoExterno, declararCandidatura, encerrarVaga, abordarCandidatos, empresaLogoUrl, baixarCurriculoCandidato, baixarCurriculoPadrao, modelosEncerramento, criarModeloEncerramento, motivosEncerramento, MOTIVOS_ENCERRAMENTO_PADRAO, TAGS_ENCERRAMENTO, RETORNOS_VAGA, SENIORIDADES, STATUS_VAGA, passoFunilVaga } from "../services/api";
import { HtmlEditor, WhatsappEditor } from "../components/RichEditors";
import { rotulo, rotuloLista } from "../utils/rotulos";
import { noSiteDaEmpresa } from "../utils/candidatura";
import { reputacaoDaEmpresa, reputacaoEmLinha } from "../utils/reputacao";

function corMatch(m) { return m >= 70 ? "bg-green-100 text-green-800" : m >= 40 ? "bg-yellow-100 text-yellow-800" : "bg-gray-100 text-gray-600"; }
function fmtSalario(min, max) {
  const f = (n) => Number(n).toLocaleString("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  if (min != null && max != null) return `R$ ${f(min)} – R$ ${f(max)}`;
  if (min != null) return `A partir de R$ ${f(min)}`;
  if (max != null) return `Até R$ ${f(max)}`;
  return "A combinar";
}
// Destino de candidatura de vaga externa: pode ser link (LinkedIn/site), e-mail ou WhatsApp/telefone.
// Detecta o tipo e monta o href correto (http / mailto / wa.me).
function hrefCandidatura(raw) {
  const s = (raw || "").trim();
  if (!s) return "#";
  if (/^https?:\/\//i.test(s)) return s;                          // já é URL
  if (/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(s)) return "mailto:" + s; // e-mail
  const digits = s.replace(/\D/g, "");
  if (/^[\d\s()+-]+$/.test(s) && digits.length >= 10)             // telefone/WhatsApp
    return "https://wa.me/" + (digits.startsWith("55") ? digits : "55" + digits);
  return "https://" + s;                                          // domínio sem esquema (ex.: lnkd.in/xxx)
}
function rotuloCanal(raw) {
  const s = (raw || "").trim();
  if (/linkedin|lnkd\.in/i.test(s)) return "LinkedIn";
  if (/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(s)) return "e-mail";
  if (/^[\d\s()+-]+$/.test(s)) return "WhatsApp";
  return "link da empresa";
}

export default function VagaPage() {
  // Popup de cursos aberto a partir da FICHA — MeCandidatar tem o seu, mas não renderiza em vaga
  // espelhada, que é justamente onde este é necessário.
  const [abrirCursos, setAbrirCursos] = useState(false);
  // 🔎 CANDIDATURA EM LOTE (29/09/2026). `de` é o marcador do post que trouxe a pessoa (?de=rpa, ?de=varejo).
  // Vai para a sessão na chegada: o candidato quase sempre passa pelo /entrar e volta SEM a query — e é
  // justamente depois do login que ele usa a lista.
  const [abrirLote, setAbrirLote] = useState(false);
  const [dePost] = useState(() => {
    try {
      const q = new URLSearchParams(window.location.search).get("de");
      if (q) sessionStorage.setItem("eairh_de", q);
      return q || sessionStorage.getItem("eairh_de");
    } catch { return null; }
  });
  // 🧪 ENTRADA GRADUAL: até o Nelson validar em produção, o botão só aparece com ?lote=1 (fica na sessão).
  // Para liberar a todos, trocar `loteLiberado` por true.
  const [loteLiberado] = useState(() => {
    try {
      if (new URLSearchParams(window.location.search).get("lote") === "1") sessionStorage.setItem("eairh_lote", "1");
      return sessionStorage.getItem("eairh_lote") === "1";
    } catch { return false; }
  });
  const { id, empresaSlug, vagaSlug } = useParams();
  const navigate = useNavigate();
  const params = useSearchParams();
  const { user, isEmpresa } = useAuth();
  const [v, setV] = useState(null);
  const [erro, setErro] = useState(null);
  const [empresaAberta, setEmpresaAberta] = useState(false);
  // Abre nas candidaturas: a empresa vem aqui para ver quem está esperando, não para reler o próprio anúncio.
  const [aba, setAba] = useState("candidaturas");
  const [qtdCand, setQtdCand] = useState(null);   // nº no rótulo da aba, sem precisar entrar nela

  // UMA única forma de (re)carregar a vaga. Dois endereços chegam aqui: /vagas/{id} (o antigo, ainda publicado
  // por aí) e /{empresa}/{vaga} (o atual) — e quem entra pelo endereço legível NÃO tem `id`. Recarregar por Id
  // depois de mudar o status pedia /vagas/undefined, a promessa quebrava calada e a tela seguia mostrando o
  // valor antigo: a empresa pausava a vaga, o banco gravava e o select continuava em "Aberta".
  const carregar = useCallback(
    () => (empresaSlug ? obterVagaPorSlug(empresaSlug, vagaSlug) : obterVaga(id)),
    [id, empresaSlug, vagaSlug]);

  // A vaga pode responder com OUTRO Id: link antigo de uma vaga que foi apagada e voltou pelo espelho. Nesse
  // caso corrigimos o endereço na barra (replace, sem entulhar o histórico) para o candidato copiar o link certo.
  useEffect(() => {
    carregar()
      .then((vaga) => {
        setV(vaga);
        if (!vaga) return;
        // 📊 Passo "abriu" do funil — é o denominador da comparação handoff x candidatura pelo eaiRH.
        // Só para VISITANTE: quem já tem conta não passa pelo atrito que estamos medindo.
        // Quem tem conta vira "abriu_logado" (19/09/2026): é a visualização que a empresa vê no painel de
        // resultados, e fica separada para não mexer no denominador da pesquisa acima.
        // A própria empresa (tipo 1) olhando a vaga dela não é visualização.
        if (user?.tipo !== 1) passoFunilVaga(vaga.id, user ? "abriu_logado" : "abriu");
        // Chegou pelo Id: leva a barra para o endereço legível, sem entulhar o histórico. Não é redirect do
        // servidor de propósito — o link por Id continua válido, só deixa de ser o que a pessoa copia daqui.
        // Preserva a query: o e-mail manda /vagas/68?candidato=123 e trocar a URL apagava o foco.
        if (!empresaSlug) {
          const destino = vaga.url || (String(vaga.id) !== String(id) ? `/vagas/${vaga.id}` : null);
          if (destino) navigate(`${destino}${window.location.search}`, { replace: true });
        }
      })
      .catch((e) => setErro(e.message));
  }, [carregar, id, empresaSlug, navigate]);

  const souDono = isEmpresa && v && user?.empresaId === v.empresaId;
  // Deep-link do e-mail: /vagas/68?candidato=123 chega na pessoa, não na página.
  const focoCandidato = Number(params[0].get("candidato")) || null;

  // Veio do e-mail sem sessão aberta: em vez de largar a pessoa na vaga pública (sem entender por que o
  // candidato não aparece), manda logar já sabendo para onde voltar.
  useEffect(() => {
    if (focoCandidato && !user) navigate(`/entrar?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`, { replace: true });
  }, [focoCandidato, user, navigate]);

  // Vaga que não existe mais (encerrada, removida ou link antigo) não pode devolver erro cru: quem chega aqui
  // veio de um e-mail de alerta, do Google ou de uma aba aberta há dias. A saída é o mural, não um beco.
  if (erro) {
    const sumiu = /404|não encontrad|nao encontrad/i.test(erro);
    return (
      <Tela>
        <div className="rounded-2xl border border-gray-200 bg-white p-8 text-center shadow-sm">
          <p className="text-4xl mb-2">{sumiu ? "🔎" : "⚠️"}</p>
          <h1 className="text-xl font-bold text-gray-900">
            {sumiu ? "Esta vaga não está mais disponível" : "Não consegui abrir esta vaga"}
          </h1>
          <p className="mt-2 text-gray-600 text-sm">
            {sumiu
              ? "Ela pode ter sido encerrada ou republicada pela empresa. As vagas abertas continuam no mural."
              : erro}
          </p>
          <button onClick={() => navigate("/vagas")}
            className="mt-5 rounded-xl bg-orange-600 hover:bg-orange-700 text-white font-semibold px-6 py-2.5">
            Ver as vagas abertas
          </button>
        </div>
      </Tela>
    );
  }
  if (!v) return <Tela><p className="text-gray-500">Carregando...</p></Tela>;

  return (
    <Tela>
      <button onClick={() => navigate("/vagas")} className="text-primary text-sm font-semibold mb-4">← Vagas</button>
      <div className="rounded-2xl border border-gray-200 bg-white p-4 md:p-6 shadow-sm">
        <div className="flex flex-wrap items-start justify-between gap-3">
          {/* min-w-0: sem isto o filho de flex não encolhe (min-width:auto) e o título longo empurra a
              largura da página inteira — no celular o conteúdo saía pela direita. */}
          <div className="flex items-start gap-3 min-w-0 flex-1">
            {v.empresaTemLogo && (
              <button onClick={() => setEmpresaAberta(true)} title={`Ver dados e reputação da ${v.empresa}`}
                className="shrink-0 rounded-lg border border-gray-200 bg-white hover:border-primary hover:shadow-sm transition">
                <img src={empresaLogoUrl(v.empresaId)} alt={v.empresa} className="h-14 w-14 rounded-lg object-contain" />
              </button>
            )}
            <div className="min-w-0">
            <h1 className="text-xl md:text-2xl font-bold text-gray-900 break-words">{v.titulo} {v.remoto && <span className="text-sm text-green-700">· remota</span>}</h1>
            <p className="text-gray-600 mt-1">
              <button onClick={() => navigate(`/empresas/${v.empresaId}`)} className="font-semibold hover:underline">{v.empresa}</button>
              {v.empresaVerificada && <span className="ml-1 text-blue-600">✔</span>}
              {v.empresaPorte && <span className="text-gray-400"> · {v.empresaPorte} porte</span>}
            </p>
            <div className="mt-2 flex flex-wrap gap-2 text-xs">
              <span className={`rounded-full px-2.5 py-1 font-semibold ${v.status === 0 ? "bg-green-100 text-green-800" : v.status === 1 ? "bg-blue-100 text-blue-800" : "bg-gray-200 text-gray-600"}`}>{v.statusTexto}</span>
              {v.areaAtuacao && <Chip>{v.areaAtuacao}</Chip>}
              {v.senioridade && <Chip>{v.senioridade}</Chip>}
              <Chip>{rotulo(v.modalidade) || (v.remoto ? "Remoto" : "Presencial")}</Chip>
              {v.cidade && <Chip>📍 {v.cidade}</Chip>}
              {/* Sem regime declarado, vale o padrão da plataforma (tempo integral) — o mesmo que vai no dado
                  estruturado do Google. Página e JSON-LD precisam dizer a MESMA coisa. */}
              <Chip>{v.tipoContratacao || "CLT ou PJ"}</Chip>
              <Chip>aberta há {v.diasEmAberto === 0 ? "hoje" : `${v.diasEmAberto}d`}</Chip>
              {v.prazoDeclaradoPelaEmpresa && v.respostaPrazoDias > 0 && <Chip>⏱️ retorno em até {v.respostaPrazoDias} dias</Chip>}
            </div>
            {/* "Esta empresa se compromete" só pode ser dito quando ELA disse. Na vaga espelhada, quem
                acompanha o retorno é o eaiRH — e a frase muda para deixar isso claro. */}
            {v.prazoDeclaradoPelaEmpresa && v.respostaPrazoDias > 0 && (
              <p className="mt-2 text-xs text-gray-500">⏱️ Esta empresa se compromete a dar retorno ao candidato em até <strong>{v.respostaPrazoDias} dias</strong>.</p>
            )}
            {(v.salarioMin != null || v.salarioMax != null) && (
              <p className="mt-2 text-sm font-semibold text-green-700">💰 {fmtSalario(v.salarioMin, v.salarioMax)}</p>
            )}
            {v.beneficios && <p className="mt-1 text-xs text-gray-500">Benefícios: {v.beneficios}</p>}
            {v.status === 4 && (
              <p className="mt-2 rounded-lg bg-gray-100 border border-gray-200 text-gray-600 px-3 py-2 text-xs">
                ⌛ Esta vaga foi <strong>encerrada por inatividade</strong> e não recebe novas candidaturas.{souDono && " Altere o status para Aberta para reabri-la."}
              </p>
            )}
            {/* PAUSADA precisa de frase, não só do selo cinza. Sem os botões (candidatar/criar conta/compartilhar
                somem fora de Aberta e Em andamento), quem chega por link antigo vê uma vaga muda e conclui que o
                site quebrou. Dizer o motivo respeita quem veio: a vaga saiu do ar, não é ela que não pode. */}
            {v.status === 2 && (
              <p className="mt-2 rounded-lg bg-amber-50 border border-amber-200 text-amber-900 px-3 py-2 text-xs">
                ⏸️ Esta vaga está <strong>pausada</strong> e não recebe novas candidaturas no momento. Ela continua aqui
                porque pode voltar a abrir — se isso acontecer, quem tem currículo no eaiRH é avisado.
                {souDono && " Altere o status para Aberta para voltar a recebê-las."}
                {/* A saída mais curta é a MESMA empresa: em 12/09 o José Carlos leu a Supervisor Administrativo
                    pausada da Reframax, não achou botão e mandou o currículo por e-mail — a Reframax tinha 12
                    vagas abertas no mural e a página não mostrava nenhuma delas. */}
                {!souDono && (v.empresaId
                  ? <> Enquanto isso, veja as <a href={`/empresas/${v.empresaId}`} className="font-semibold underline">outras vagas abertas da {v.empresa}</a> ou <a href="/vagas" className="font-semibold underline">todo o mural</a>.</>
                  : <> Enquanto isso, <a href="/vagas" className="font-semibold underline">veja as vagas abertas</a>.</>)}
              </p>
            )}
            {/* Vaga encerrada pela empresa: a página continua no ar, assumida como encerrada. É a prova pública
                de que a empresa fechou o ciclo — e o motivo só aparece quando ela quis informar. */}
            {v.status === 3 && v.encerradaEm && (
              <p className="mt-2 rounded-lg bg-gray-100 border border-gray-200 text-gray-700 px-3 py-2 text-xs">
                🔒 <strong>Vaga encerrada</strong> em {new Date(v.encerradaEm).toLocaleDateString("pt-BR")}
                {v.encerradaSemContratacao ? " sem contratação" : ""}
                {v.motivoEncerramento ? <> — {v.motivoEncerramento}.</> : "."}
                {" "}Os candidatos foram avisados.
              </p>
            )}

            {/* PORTA DE SAÍDA DA VAGA FECHADA.
                O aviso acima explica por que não há botão, mas explicar não resolve: a pessoa leu o anúncio
                inteiro e continua sem ter o que fazer. Em dois dias, nove pessoas chegaram a vagas fechadas por
                link antigo ou por busca — que continuam existindo depois que o processo encerra — e várias
                ficaram mais de um minuto lendo. Quem lê uma vaga fechada é exatamente o público da vaga aberta
                do mesmo perfil: quem chega na Python JR pausada é quem procura a Python SR, que está no ar.
                O backend só preenche `similares` quando a vaga está fechada, então isto nunca disputa atenção
                com quem pode se candidatar agora. */}
            {v.similares?.length > 0 && (
              <div className="mt-4 rounded-xl border border-primary/30 bg-primary/5 p-4">
                <p className="text-sm font-semibold text-gray-900">Estas estão abertas agora</p>
                <ul className="mt-2 space-y-2">
                  {v.similares.map((s) => (
                    <li key={s.id}>
                      <a href={s.url || `/vagas/${s.id}`} className="text-sm font-semibold text-primary hover:underline">
                        {s.titulo}
                      </a>
                      <span className="block text-xs text-gray-600">
                        {s.empresa}{s.cidade ? ` · ${s.cidade}` : ""}{s.modalidade ? ` · ${s.modalidade}` : ""}
                      </span>
                    </li>
                  ))}
                </ul>
                <a href="/vagas" className="mt-3 inline-block text-xs font-semibold text-primary hover:underline">
                  Ver todas as vagas abertas
                </a>
              </div>
            )}
            </div>
          </div>
          <div className="text-center shrink-0">
            {(() => {
              const r = reputacaoEmLinha(v.empresaScore, v.empresaSelo, v.empresaClassificacao);
              return <span className={`inline-block rounded-full px-3 py-1 text-sm font-bold ${r.cor}`} title={r.titulo}>{r.texto}</span>;
            })()}
            {v.empresaAlertas?.length > 0 && <div className="mt-2 text-xs text-amber-700">{v.empresaAlertas.join(" · ")}</div>}
          </div>
        </div>

        {/* Candidato: me candidatar | Empresa dona: mudar status */}
        {/* Vaga EXTERNA (divulgada pelo eaiRH): candidatura vai pro canal original (LinkedIn, site, e-mail ou WhatsApp). */}
        <div id="cta-candidatura">
        {/* 🚨 VAGA ESPELHADA DE PORTAL, CANDIDATO LOGADO: o mesmo handoff acompanhado da vaga "só no site da
            empresa" (acordo › abre o site › "Conseguiu?"). Antes caía no <a> solto abaixo e a ida sumia do funil
            (Carlos 13/09, Bruno 14/09/2026). Visitante e empresa seguem vendo o link direto. */}
        {user?.tipo === 0 && (v.status === 0 || v.status === 1) && v.fonte === "Externa" && noSiteDaEmpresa(v) ? (
          <CandidaturaNoSite vaga={{ ...v, urlCandidaturaExterna: v.urlCandidaturaExterna || hrefCandidatura(v.urlExterna) }} />
        ) : v.fonte === "Externa" && v.urlExterna && (v.status === 0 || v.status === 1) ? (
          <div className="mt-4">
            <a href={hrefCandidatura(v.urlExterna)} target="_blank" rel="noopener noreferrer"
              onClick={() => passoFunilVaga(v.id, "abriu_site")}
              className="inline-block rounded-xl bg-orange-600 hover:bg-orange-700 text-white font-semibold px-6 py-2.5">
              Candidatar-se →
            </a>
            <p className="text-[11px] text-gray-400 mt-1">Vaga divulgada no eaiRH — a candidatura é feita no canal indicado pela empresa ({rotuloCanal(v.urlExterna)}).</p>
          </div>
        ) : (
          <>
            {/* SÓ NO SITE DA EMPRESA: o conector do ATS barra e não há e-mail. Em vez de esconder a vaga,
                o eaiRH leva a pessoa até lá com consentimento e continua acompanhando. */}
            {user?.tipo === 0 && (v.status === 0 || v.status === 1) && v.soNoSiteDaEmpresa
              ? <CandidaturaNoSite vaga={v} />
              : user?.tipo === 0 && (v.status === 0 || v.status === 1) && <MeCandidatar vagaId={v.id} vaga={v} />}
            {/* VISITANTE: a mensagem antiga ("entre na sua conta para se candidatar") era discreta demais —
                um candidato sênior clicou, caiu no cadastro, saiu no meio e ficou convencido de que tinha se
                candidatado. A empresa nunca soube que ele existiu. Agora a tela diz, sem rodeio, que a
                candidatura AINDA NÃO foi enviada, e o botão volta para esta vaga depois do login. */}
            {/* 🚨 QUEM VEM DO LEMBRETE (?confirmar=1) JÁ SE CANDIDATOU — só falta dizer. O Diego (10/09) clicou
                no e-mail, caiu aqui deslogado e leu "Você ainda não se candidatou"; entrou, e o retorno ia para
                /vagas/{id} SEM o ?confirmar=1 — a pergunta sumia. Ele desistiu e respondeu o e-mail na mão.
                Agora o texto fala com quem já foi, e o retorno leva a URL inteira, com a pergunta junto. */}
            {!user && (v.status === 0 || v.status === 1) && (() => {
              const veioConfirmar = new URLSearchParams(window.location.search).get("confirmar") === "1";
              const volta = veioConfirmar ? `${window.location.pathname}?confirmar=1` : `/vagas/${v.id}`;
              return (
              <div className="mt-4 rounded-xl border border-amber-300 bg-amber-50 p-4">
                <p className="font-bold text-amber-900">
                  {veioConfirmar ? "Entre para confirmar a sua candidatura" : "Você ainda não se candidatou a esta vaga"}
                </p>
                <p className="text-sm text-amber-800 mt-1">
                  {veioConfirmar
                    ? "É só entrar na sua conta: você volta direto para a pergunta e responde em um clique."
                    : "Para a empresa receber seu currículo é preciso ter uma conta no eaiRH — é gratuito e leva menos de um minuto. Você volta direto para esta vaga depois de entrar."}
                </p>
                {/* ⚠️ `cadastro=1` E `motivo` NA URL, NÃO no state do router (18/09/2026).
                    A pessoa vinha para cá SEM os dois, e o LoginPage decide a aba assim:
                        useState((location.state?.from || _cadastroQuery) ? "cadastro" : "login")
                    Sem nenhum deles, a tela abria em ENTRAR — pedindo e-mail e senha a quem nunca teve
                    conta. Em 18/09 quatro pessoas fizeram esse caminho e saíram do /entrar em 3, 4, 12 e
                    48 segundos, TODAS voltando para a vaga depois: o interesse continuava, a tela é que
                    barrava. Duas delas vieram do bloco de RPA do WhatsApp, o público mais quente que temos.
                    O `motivo` também dependia do state — então o texto que explica POR QUE precisa de conta
                    (escrito logo acima, e bom) sumia justamente na hora de decidir. */}
                <button onClick={() => { passoFunilVaga(v.id, "clicou_entrar");
                  const q = new URLSearchParams({
                    redirect: volta,
                    ...(veioConfirmar ? {} : { cadastro: "1" }),
                    motivo: veioConfirmar
                      ? "Entre na sua conta para confirmar a candidatura — você volta direto para a pergunta."
                      : "Crie sua conta para se candidatar: é gratuito, leva menos de um minuto e você volta direto para esta vaga.",
                  });
                  navigate(`/entrar?${q.toString()}`); }}
                  className="mt-3 rounded-xl bg-orange-600 hover:bg-orange-700 text-white font-semibold px-5 py-2">
                  {veioConfirmar ? "Entrar e confirmar" : "Criar conta e me candidatar"}
                </button>
              </div>
              );
            })()}
          </>
        )}
        {/* 🔎 VER VAGAS SEMELHANTES — candidato logado, vaga aberta. Abre a lista para se candidatar a várias. */}
        {loteLiberado && user?.tipo === 0 && (v.status === 0 || v.status === 1) && (
          <div className="mt-3">
            <button onClick={() => setAbrirLote(true)}
              className="rounded-xl border-2 border-primary px-5 py-2 font-semibold text-primary hover:bg-primary/5">
              🔎 Ver vagas semelhantes
            </button>
            <p className="mt-1 text-[11px] text-gray-500">Marque outras vagas que combinam com você e se candidate a várias de uma vez.</p>
          </div>
        )}
        </div>
        <CandidaturaEmLote vaga={v} de={dePost} aberto={abrirLote} onFechar={() => setAbrirLote(false)} ModalEntrega={ModalEntrega} />
        {/* Compartilhar: indicar vaga a um amigo é o alcance mais barato que temos, e o link cru no WhatsApp
            não converte. Fica abaixo da candidatura de propósito — primeiro a pessoa decide por si. */}
        {/* "Conhece alguém pra esta vaga?" é fala para quem visita e pode indicar um amigo. Para a empresa que
            publicou a vaga soa deslocado — ela não indica, ela contrata. Some para o dono. */}
        {!souDono && (v.status === 0 || v.status === 1) && <CompartilharVaga vaga={v} className="mt-4" />}

        {/* ABAS — só para a empresa dona. Ela entra aqui para AGIR sobre quem está esperando, não para reler a
            própria vaga; deixar as candidaturas no fim da página obrigava a rolar tudo a cada visita. Por isso a
            aba de candidaturas é a que abre. Para candidato e visitante nada muda: a página segue corrida. */}
        {souDono && (
          <div className="mt-5 flex gap-1 border-b border-gray-200">
            {[["candidaturas", `Candidaturas${qtdCand != null ? ` (${qtdCand})` : ""}`], ["vaga", "Dados da vaga"]].map(([k, t]) => (
              <button key={k} onClick={() => setAba(k)}
                className={`px-4 py-2 text-sm font-semibold rounded-t-lg ${aba === k
                  ? "bg-white border border-gray-200 border-b-white text-primary -mb-px"
                  : "text-gray-500 hover:text-gray-800"}`}>{t}</button>
            ))}
          </div>
        )}

        {souDono && aba === "candidaturas" && (
          <CandidaturasRecebidas vagaId={v.id} vagaTitulo={v.titulo} vaga={v} foco={focoCandidato} onQtd={setQtdCand} />
        )}

        {(!souDono || aba === "vaga") && (<>
        {souDono && <MudarStatus vaga={v} onOk={() => carregar().then(setV).catch((e) => setErro(e.message))} />}
        {souDono && <FecharVaga vaga={v} onOk={() => carregar().then(setV).catch((e) => setErro(e.message))} />}
        {/* FICHA DA VAGA — os mesmos campos do formulário de publicação, lado a lado. Antes só existiam como
            chips pequenos no topo, misturados ao status: o candidato não achava cidade nem contratação, e a
            vaga espelhada parecia pela metade ao lado de uma cadastrada à mão. */}
        <div className="mt-5 rounded-xl border border-gray-200 bg-gray-50/60 p-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-3 text-sm">
            <Dado rotulo="Área">{v.areaAtuacao}</Dado>
            <Dado rotulo="Senioridade">{v.senioridade}</Dado>
            <Dado rotulo="Cidade">{v.cidade || (v.modalidade === "Remoto" || v.remoto ? "Remoto (qualquer lugar)" : null)}</Dado>
            <Dado rotulo="Modalidade">{rotulo(v.modalidade) || (v.remoto ? "Remoto" : "Presencial")}</Dado>
            <Dado rotulo="Tipo de contratação">{v.tipoContratacao || "CLT ou PJ (a definir com a empresa)"}</Dado>
            <Dado rotulo="Salário">{(v.salarioMin != null || v.salarioMax != null) ? fmtSalario(v.salarioMin, v.salarioMax) : "A combinar"}</Dado>
            <Dado rotulo="Retorno ao candidato">{v.prazoDeclaradoPelaEmpresa && v.respostaPrazoDias > 0 ? `em até ${v.respostaPrazoDias} dias` : null}</Dado>
            <Dado rotulo="Vaga publicada há">{v.diasEmAberto === 0 ? "hoje" : `${v.diasEmAberto} dias`}</Dado>
            {/* Onde a candidatura acontece entra na FICHA, ao lado de cidade e contratacao: e informacao
                da vaga como qualquer outra, e quem le a ficha inteira antes de decidir merece encontra-la
                ali — nao so no aviso embaixo do botao. */}
            <Dado rotulo="Candidatura">{noSiteDaEmpresa(v) ? "No site da empresa"
              : v.fonte === "Externa" && v.urlExterna ? `Pelo canal da empresa (${rotuloCanal(v.urlExterna)})` : "Pelo eaiRH"}</Dado>
            {v.beneficios && <div className="col-span-2 md:col-span-4"><Dado rotulo="Benefícios">{v.beneficios}</Dado></div>}
          </div>
          {v.skills?.length > 0 && (
            <div className="mt-4 pt-3 border-t border-gray-200 space-y-3">
              {/* 🎯 TRÊS LISTAS, NÃO UMA LISTA COLORIDA (25/09/2026).

                  O pedido do Nelson foi literal: *"o certo seria skills desejadas, skills encontradas,
                  skills faltantes (nesse ter o botão)"*. A primeira tentativa foi pintar a mesma lista de
                  verde e vermelho, e ele está certo em separar: cor pede que a pessoa decifre a legenda,
                  três títulos dizem a mesma coisa lendo.

                  O comparativo já existia, mas como frase dentro do balão de aderência — que vive em
                  MeCandidatar e só renderiza quando a candidatura acontece aqui. Em vaga espelhada (a
                  maior parte do mural) quem renderiza é CandidaturaNoSite, e a pessoa não via nem a
                  aderência nem o botão de cursos. Na ficha, aparece em qualquer vaga.

                  Sem currículo para comparar, fica só a primeira lista: dizer "falta" para quem a gente
                  não conhece seria invenção. */}
              <div>
                <div className="text-[11px] uppercase tracking-wide text-gray-500 font-semibold mb-1.5">Skills desejadas</div>
                {/* 🙈 A SIGLA REDUNDANTE SOME DA TELA, NÃO DO BANCO (26/09/2026).

                    A vaga que pede "Power BI" costuma trazer "BI" junto, e a lista ficava com as duas —
                    o Nelson viu e perguntou *"por que BI e Power BI?"*.

                    A primeira tentativa foi apagar do banco, e estava errada: o campo de skills é o que
                    casa com o currículo, e quem escreveu só "BI", "ERP" ou "SQL" deixaria de dar match.
                    Some daqui, continua lá. */}
                <div className="flex flex-wrap gap-1.5">{semSiglaRedundante(v.skills).map((s) => <Chip key={s} azul>{s}</Chip>)}</div>
              </div>

              {v.matchTem?.length > 0 && (
                <div>
                  <div className="text-[11px] uppercase tracking-wide text-green-700 font-semibold mb-1.5">
                    Skills encontradas no seu currículo ({v.matchTem.length})
                  </div>
                  <div className="flex flex-wrap gap-1.5">{v.matchTem.map((s) => <Chip key={s} tem>{s}</Chip>)}</div>
                </div>
              )}

              {v.matchFaltando?.length > 0 && (
                <div>
                  <div className="text-[11px] uppercase tracking-wide text-red-700 font-semibold mb-1.5">
                    Skills faltantes ({v.matchFaltando.length})
                  </div>
                  <div className="flex flex-wrap gap-1.5">{v.matchFaltando.map((s) => <Chip key={s} falta>{s}</Chip>)}</div>
                  <button type="button" onClick={() => setAbrirCursos(true)}
                    className="mt-2 rounded-xl bg-orange-600 px-4 py-2 text-xs font-bold text-white shadow hover:bg-orange-700">
                    Melhorar minhas skills
                  </button>
                  <p className="mt-1 text-[11px] text-gray-500">
                    Onde aprender cada uma — cursos gratuitos primeiro. Ao concluir, a skill entra no seu currículo e melhora seu match.
                  </p>
                </div>
              )}
            </div>
          )}
        </div>
        {v.descricao && <p className="mt-4 text-gray-700 text-sm whitespace-pre-line">{v.descricao}</p>}
        {/* O botão só existia no topo: quem lia a descrição inteira (29 s a 2 min) chegava ao fim sem botão
            (Carlos 13/09, Bruno 14/09/2026). Este leva de volta a ele — um CTA só, para não duplicar o fluxo. */}
        {user?.tipo === 0 && !souDono && (v.status === 0 || v.status === 1) && v.descricao && (
          <div className="mt-5">
            <button type="button" onClick={() => document.getElementById("cta-candidatura")?.scrollIntoView({ behavior: "smooth", block: "center" })}
              className="rounded-xl bg-orange-600 hover:bg-orange-700 text-white font-semibold px-6 py-2.5">
              Quero me candidatar ↑
            </button>
          </div>
        )}
        </>)}
      </div>

      {empresaAberta && <ModalEmpresa vaga={v} onFechar={() => setEmpresaAberta(false)} />}
      {/* Popup de cursos aberto pela lista de skills faltantes da FICHA. MeCandidatar monta o seu
          proprio, mas nao renderiza em vaga espelhada — que e onde este e necessario. */}
      <MelhorarSkills aberto={abrirCursos} onFechar={() => setAbrirCursos(false)} skillsDaVaga={v.matchFaltando} vagaId={v.id} />
    </Tela>
  );
}

/**
 * CANDIDATURA NO SITE DA EMPRESA - o handoff acompanhado.
 *
 * Existe para a vaga que o eaiRH consegue LER mas nao consegue ENTREGAR: o ATS da empresa exige campos
 * que nao temos (data de nascimento, endereco, perguntas proprias da vaga) e o anuncio nao publica e-mail.
 *
 * Ate 06/09/2026 essa vaga era simplesmente escondida. Esconder nao ajudava ninguem: a vaga existe, a
 * pessoa quer se candidatar, e o eaiRH sabe onde ela esta. O que nao podia era PROMETER uma entrega que
 * nao acontece. A saida e levar a pessoa ate la com consentimento e continuar acompanhando o processo
 * pelo que ela contar - porque medir o retorno e o produto, e sem ninguem dentro do funil nao ha o que medir.
 *
 * Tres passos, nesta ordem, e nenhum e decorativo:
 *   1. acordo    - ela sabe para onde vai e o que a gente pede em troca
 *   2. voltou?   - "nao consegui" vale tanto quanto "sim": e porta quebrada do lado da empresa
 *   3. contato   - quem falou com ela, para podermos cobrar o retorno de forma nominal
 */
// MOTIVO EM UM TOQUE — para a janela de envio (quando a cadeia ATS → e-mail se esgota e sobra o site da
// empresa). Mesma lista e mesma rota da tela do handoff; fora do componente pai para não ser recriado a cada
// render (ver o comentário da FeedbackCandidaturaPage sobre foco perdido).
function MotivoRapido({ vagaId }) {
  const [escolhido, setEscolhido] = useState(null);
  if (escolhido) return <p className="text-sm text-gray-700 mt-2">Anotado, obrigado. Isso nos ajuda a melhorar o caminho até a vaga.</p>;
  return (
    <div className="mt-2 flex flex-col gap-1.5">
      {MOTIVOS_NAO_CONSEGUIU.map((m) => (
        <button key={m.v} type="button"
          onClick={() => { setEscolhido(m.v); declararCandidatura(vagaId, { naoConsegui: true, motivo: m.v }).catch(() => {}); }}
          className="max-w-full whitespace-normal text-left rounded-lg border-2 border-orange-300 bg-white hover:bg-orange-50 hover:border-orange-500 px-3 py-2 text-sm font-semibold text-gray-800">
          {m.t}
        </button>
      ))}
    </div>
  );
}

function CandidaturaNoSite({ vaga }) {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [perfil, setPerfil] = useState(undefined); // undefined = carregando
  // ?confirmar=1 vem do e-mail de lembrete e abre DIRETO na pergunta. Quem clica ali ja leu a vaga e esta
  // respondendo uma pergunta — fazer a pessoa recomecar pelo modal do acordo seria desperdicar o clique.
  const [passo, setPasso] = useState(params.get("confirmar") === "1" ? "voltou" : null);
  const [erro, setErro] = useState(null);
  const [salvando, setSalvando] = useState(false);
  // POR QUE NÃO CONSEGUIU (11/09/2026) — informação nossa, não relato. O toque em "Não consegui" registra na
  // hora (a pessoa pode fechar a aba); o motivo vem numa segunda chamada, quando ela escolhe.
  const [motivo, setMotivo] = useState(null);
  const [motivoTexto, setMotivoTexto] = useState("");
  const [baixandoPdf, setBaixandoPdf] = useState(false);
  const [pdfOk, setPdfOk] = useState(false);

  async function baixarPdf() {
    setBaixandoPdf(true); setErro(null);
    try { await baixarCurriculoGerado(); setPdfOk(true); }
    catch (e) { setErro(e.message || "Não consegui gerar o PDF agora."); }
    finally { setBaixandoPdf(false); }
  }

  async function enviar(dados, proximo) {
    setSalvando(true); setErro(null);
    try {
      await declararCandidatura(vaga.id, dados);
      setPasso(proximo);
    } catch (e) {
      setErro(e.message || "Nao consegui registrar. Tente de novo.");
    } finally {
      setSalvando(false);
    }
  }

  // O link abre ANTES de registrar: se o registro falhar, a pessoa nao fica sem se candidatar por causa
  // de um erro nosso. O registro e problema nosso, a vaga e dela.
  function concordar() {
    window.open(vaga.urlCandidaturaExterna, "_blank", "noopener,noreferrer");
    setPasso("voltou");
    // Registra a IDA sem esperar resposta. Serve para o unico lembrete: quem abre a vaga e some seria
    // invisivel, e o funil vazaria em silencio justamente no passo que criamos.
    // NAO cria candidatura — so a confirmacao cria.
    declararCandidatura(vaga.id, { abriu: true }).catch(() => {});
  }

  useEffect(() => { obterMeuPerfil().then(setPerfil).catch(() => setPerfil(null)); }, []);

  // 🔁 A ABA ESQUECE; O BANCO NAO (23/09/2026).
  //
  // Candidato real, pelo WhatsApp: abriu a vaga da Stefanini (Gupy), se candidatou la, voltou ao
  // eaiRH — e a pergunta nao apareceu. *"Veio nada para confirmar nao."* O `passo` so vira "voltou"
  // pelo clique do botao NESTA aba; quem recarrega, navega ou tem a aba descartada pelo celular
  // perde o estado — mesmo com a ida ja gravada no banco (a dele estava la, 14:25:32).
  //
  // 📉 E isso reescreve um numero: o funil tem 212 aberturas para 71 confirmacoes, e eu lia as 110
  // que "nunca voltaram" como desistencia. Parte voltou e nao viu pergunta nenhuma.
  //
  // Agora a pagina pergunta ao servidor o que a aba esqueceu.
  //
  // ⚠️ So reabre se NAO houver nada aberto (`passo === null`): o ?confirmar=1 do e-mail e o modal que
  // a pessoa acabou de abrir valem mais que a nossa reabertura.
  useEffect(() => {
    if (!vaga?.id || passo !== null) return;
    let vivo = true;
    minhaIntencao(vaga.id)
      .then((r) => { if (vivo && r?.pendente) setPasso("voltou"); })
      .catch(() => { /* sem login ou sem intencao: a pagina segue igual */ });
    return () => { vivo = false; };
  }, [vaga?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  // 💡 CURRÍCULO: SUGESTÃO, NUNCA TRAVA — decisão do Nelson em 08/09/2026, depois do Alessandro.
  //
  // Ele se cadastrou, se candidatou numa vaga da TOPMIND pelo site da empresa e mandou DM dizendo
  // "já enviei". No eaiRH não havia candidatura nem currículo: perfil vazio, fora do aviso diário de
  // vagas, e sem saber disso. Estava perdendo oportunidade em silêncio.
  //
  // 🚨 A PRIMEIRA VERSÃO DISTO BARRAVA O BOTÃO, e o Nelson mandou desfazer na hora: "não obrigue a
  // cadastrar, sugira". Ele está certo — a vaga é da pessoa, não nossa. Barrar a saída para o site da
  // empresa é cobrar pedágio por algo que ela consegue fazer sozinha em outra aba, e o portal ainda
  // sairia perdendo: ela vai embora, se candidata por fora e some do funil de vez.
  //
  // ⚠️ E O TEXTO NÃO PODE SER O DO MeCandidatar. A diferença é de VERDADE, não de estilo: lá o
  // currículo VAI para a empresa junto com a candidatura. Aqui ele NÃO VAI — quem recebe é o site da
  // empresa, e o currículo que conta é o que a pessoa subir lá. Repetir a frase do outro fluxo seria
  // prometer o que não acontece. O que o currículo faz AQUI é uma coisa só, e é essa que se promete:
  // entrar no cruzamento diário do mural e receber por e-mail as vagas que combinam.
  const temCurriculo = !!perfil && ((perfil.experiencias?.length || 0) > 0 || (perfil.skills?.length || 0) > 0 || !!perfil.temCurriculo);
  const sugerirCurriculo = perfil !== undefined && !temCurriculo;

  if (passo === null) {
    return (
      <div className="mt-4">
        {sugerirCurriculo && (
          <div className="mb-3 rounded-xl border border-amber-200 bg-amber-50 p-4">
            <p className="font-bold text-amber-900">Já que você está por aqui: falta seu currículo</p>
            <p className="text-sm text-amber-800 mt-1">
              Nesta vaga a candidatura acontece no site da empresa, e o currículo que conta é o que você
              enviar por lá. O daqui serve para outra coisa: todo dia o mural é cruzado com o seu perfil
              e as vagas que combinam chegam no seu e-mail. São quase 8 mil vagas — com o currículo,
              elas passam a te procurar.
            </p>
            <button onClick={() => navigate(`/curriculo?voltar=${encodeURIComponent(window.location.pathname)}`)}
              className="mt-3 rounded-xl border border-orange-600 text-orange-700 hover:bg-orange-50 font-semibold px-5 py-2">
              Preencher meu currículo
            </button>
            <p className="text-[11px] text-amber-700 mt-2">
              Pode deixar para depois — dá para se candidatar agora mesmo, no botão abaixo.
            </p>
          </div>
        )}
        <button onClick={() => setPasso("acordo")}
          className="inline-block rounded-xl bg-orange-600 hover:bg-orange-700 text-white font-semibold px-6 py-2.5">
          Candidatar-se &rarr;
        </button>
        <p className="text-[11px] text-gray-500 mt-1">
          Esta empresa recebe candidaturas no site dela. O eaiRH acompanha o seu processo se voc&ecirc; nos contar como foi.
        </p>
      </div>
    );
  }

  return (
    <Modal aoFechar={() => setPasso(null)}>
      {erro && <p className="mb-3 rounded-lg bg-red-50 border border-red-200 text-red-800 px-3 py-2 text-sm">{erro}</p>}

      {passo === "acordo" && (<>
        <h3 className="text-lg font-bold text-gray-900">Voc&ecirc; vai se candidatar no site da {vaga.empresa}</h3>
        <p className="mt-2 text-sm text-gray-700">
          Esta vaga recebe candidaturas apenas pelo site da empresa. Vamos te levar at&eacute; l&aacute;.
        </p>
        <p className="mt-2 text-sm text-gray-700">
          Em troca, pedimos uma coisa: <b>volte aqui e nos conte</b> se conseguiu se candidatar. &Eacute; assim que o
          eaiRH acompanha se a empresa d&aacute; retorno &mdash; e &eacute; isso que a gente cobra dela por voc&ecirc;.
        </p>
        {/* O CURRÍCULO EM ARQUIVO, ANTES DE SAIR (11/09/2026). Pintor e Soldador da Reframax passaram 7 e 11 min
            no formulário do QuickIn e voltaram com "não consegui": ele exige o currículo ANEXADO, e o público
            operacional não tem PDF. O eaiRH já gera esse PDF do perfil — só não aparecia na hora em que ele serve. */}
        {temCurriculo && (
          <div className="mt-3 rounded-xl border border-amber-200 bg-amber-50 p-3">
            <p className="text-sm text-amber-900">
              <b>Dica:</b> o site da empresa costuma pedir o <b>currículo em arquivo</b>. Baixe antes o seu, feito pelo eaiRH, para anexar l&aacute;.
            </p>
            <button type="button" onClick={baixarPdf} disabled={baixandoPdf}
              className="mt-2 rounded-lg border border-orange-600 text-orange-700 hover:bg-orange-50 font-semibold px-4 py-1.5 text-sm disabled:opacity-60">
              {baixandoPdf ? "Gerando PDF..." : pdfOk ? "PDF baixado ✓ (veja seus downloads)" : "Baixar meu currículo em PDF"}
            </button>
          </div>
        )}
        <div className="mt-4 flex flex-wrap gap-2">
          <button onClick={concordar}
            className="rounded-xl bg-orange-600 hover:bg-orange-700 text-white font-semibold px-5 py-2.5">
            Concordo, abrir a vaga
          </button>
          <button onClick={() => setPasso(null)}
            className="rounded-xl border border-gray-300 hover:bg-gray-50 text-gray-700 font-semibold px-5 py-2.5">
            Cancelar
          </button>
        </div>
      </>)}

      {passo === "voltou" && (<>
        <h3 className="text-lg font-bold text-gray-900">Conseguiu se candidatar?</h3>
        <p className="mt-2 text-sm text-gray-700">
          A p&aacute;gina da vaga abriu em outra aba. Quando terminar, responda aqui.
        </p>
        <div className="mt-4 flex flex-wrap gap-2">
          <button disabled={salvando} onClick={() => enviar({ naoConsegui: false }, "contato")}
            className="rounded-xl bg-primary hover:opacity-90 text-white font-semibold px-5 py-2.5 disabled:opacity-60">
            {salvando ? "Registrando..." : "Sim, me candidatei"}
          </button>
          {/* "Nao consegui" NAO e o botao de desistir: e um dado que ninguem mais coleta. Formulario fora
              do ar e vaga fantasma sao exatamente o que o portal existe para expor. */}
          <button disabled={salvando} onClick={() => enviar({ naoConsegui: true }, "motivo")}
            className="rounded-xl border border-gray-300 hover:bg-gray-50 text-gray-700 font-semibold px-5 py-2.5 disabled:opacity-60">
            N&atilde;o consegui
          </button>
        </div>
      </>)}

      {/* CONFIRMOU — e aqui NAO se pede quem entrou em contato.
          O Nelson corrigiu o desenho em 06/09/2026: "esse de pessoa que contactou ele nao tem agora,
          somente quando a empresa entrar em contato". Pedir nome de recrutador no segundo seguinte a
          candidatura e pedir um dado que ainda nao existe — a pessoa fecha o modal sem preencher e a
          gente conclui, errado, que ela nao quis colaborar.
          A pergunta vai por e-mail depois (7 e 15 dias), quando ja ha o que responder. */}
      {passo === "contato" && (<>
        <h3 className="text-lg font-bold text-gray-900">Candidatura registrada</h3>
        <p className="mt-2 text-sm text-gray-700">
          Anotamos que voc&ecirc; se candidatou a esta vaga. A partir de agora o eaiRH acompanha esse processo por voc&ecirc;.
        </p>
        <p className="mt-2 text-sm text-gray-700">
          Em <b>7 dias</b> vamos te perguntar por e-mail se algu&eacute;m da empresa entrou em contato. &Eacute; uma pergunta
          s&oacute;, e &eacute; a sua resposta que forma a reputa&ccedil;&atilde;o dela aqui &mdash; a mesma que ajudou voc&ecirc; a decidir se valia
          a pena se candidatar.
        </p>
        <p className="mt-2 text-xs text-gray-500">
          Voc&ecirc; tamb&eacute;m pode responder quando quiser em <b>Minhas candidaturas</b>, sem esperar o e-mail.
        </p>
        <div className="mt-4 flex flex-wrap gap-2">
          <button onClick={() => setPasso("fim")}
            className="rounded-xl bg-primary hover:opacity-90 text-white font-semibold px-5 py-2.5">
            Entendi
          </button>
          <a href="/vagas" className="rounded-xl border border-gray-300 hover:bg-gray-50 text-gray-700 font-semibold px-5 py-2.5">
            Ver outras vagas
          </a>
        </div>
      </>)}

      {/* DESFECHO DE QUEM NAO CONSEGUIU — tela propria, e nao e detalhe.
          Ate 06/09/2026 este caminho caia na mesma tela do "fim" e dizia "sua candidatura ficou
          registrada". Era MENTIRA: nao ha candidatura nenhuma. O Nelson viu no mockup e apontou.
          A regra vale aqui como vale para fora: omitir a causa interna pode, afirmar o que nao aconteceu
          nao pode. */}
      {/* O "NÃO CONSEGUI" ABRE UM FORMULÁRIO (pedido do Nelson, 11/09/2026). O registro já foi feito no toque;
          aqui só se pergunta o motivo. Informação NOSSA, não relato — e a tela diz isso, porque quem acha que
          está denunciando a empresa escreve outra coisa. Pular é permitido: quem pula recebe UM e-mail depois. */}
      {passo === "motivo" && (<>
        <h3 className="text-lg font-bold text-gray-900">O que aconteceu?</h3>
        <p className="mt-1 text-xs text-gray-500">
          N&atilde;o &eacute; um relato p&uacute;blico e n&atilde;o vai para a empresa: &eacute; s&oacute; para a gente entender onde o caminho trava.
        </p>
        <div className="mt-3 flex flex-col gap-2">
          {MOTIVOS_NAO_CONSEGUIU.map((m) => (
            <button key={m.v} type="button" onClick={() => setMotivo(m.v)}
              className={`max-w-full whitespace-normal text-left rounded-xl border px-3 py-2 text-sm font-semibold ${motivo === m.v
                ? "border-primary bg-primary text-white" : "border-gray-300 bg-white text-gray-700 hover:bg-gray-50"}`}>
              {m.t}
            </button>
          ))}
        </div>
        <textarea value={motivoTexto} onChange={(e) => setMotivoTexto(e.target.value)} rows={3} maxLength={1000}
          placeholder="Se quiser, conte com as suas palavras (opcional)"
          className="mt-3 w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:border-primary focus:outline-none" />
        <div className="mt-3 flex flex-wrap gap-2">
          <button disabled={!motivo || salvando}
            onClick={() => enviar({ naoConsegui: true, motivo, motivoTexto: motivoTexto.trim() || null }, "naoDeu")}
            className="rounded-xl bg-primary hover:opacity-90 text-white font-semibold px-5 py-2.5 disabled:opacity-50">
            {salvando ? "Enviando..." : "Enviar"}
          </button>
          <button onClick={() => setPasso("naoDeu")}
            className="rounded-xl border border-gray-300 hover:bg-gray-50 text-gray-700 font-semibold px-5 py-2.5">
            Pular
          </button>
        </div>
      </>)}

      {passo === "naoDeu" && (<>
        <h3 className="text-lg font-bold text-gray-900">Obrigado por avisar</h3>
        <p className="mt-2 text-sm text-gray-700">
          Registramos que <b>voc&ecirc; n&atilde;o conseguiu se candidatar</b> a esta vaga. Nenhuma candidatura foi criada &mdash;
          nada ficou pendente no seu nome.
        </p>
        {/* Texto corrigido em 11/09/2026: dizia "é problema da empresa" e "aparece na reputação". Nem sempre é —
            o formulário da Reframax funciona, só pede currículo em arquivo — e o motivo é informação nossa. */}
        <p className="mt-2 text-sm text-gray-700">
          Isso n&atilde;o &eacute; culpa sua. Saber onde o caminho trava &eacute; o que nos ajuda a melhor&aacute;-lo para voc&ecirc; e para quem vem depois.
        </p>
        {motivo === "curriculo_arquivo" && (
          <div className="mt-3 rounded-xl border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900">
            O eaiRH gera o seu curr&iacute;culo em PDF para voc&ecirc; anexar no site da empresa.
            <button type="button" onClick={baixarPdf} disabled={baixandoPdf}
              className="block mt-2 font-semibold text-orange-700 underline disabled:opacity-60">
              {baixandoPdf ? "Gerando PDF..." : pdfOk ? "PDF baixado ✓" : "Baixar meu currículo em PDF"}
            </button>
          </div>
        )}
        <div className="mt-4 flex flex-wrap gap-2">
          <a href="/vagas" className="rounded-xl bg-primary hover:opacity-90 text-white font-semibold px-5 py-2.5">
            Ver outras vagas abertas
          </a>
          <button onClick={() => setPasso("voltou")}
            className="rounded-xl border border-gray-300 hover:bg-gray-50 text-gray-700 font-semibold px-5 py-2.5">
            Consegui, na verdade
          </button>
        </div>
      </>)}

      {passo === "fim" && (<>
        <h3 className="text-lg font-bold text-gray-900">Pronto, obrigado!</h3>
        <p className="mt-2 text-sm text-gray-700">
          Sua candidatura ficou registrada no eaiRH. Vamos te perguntar em alguns dias se a empresa deu retorno &mdash;
          e &eacute; a sua resposta que forma a reputa&ccedil;&atilde;o dela aqui.
        </p>
        <div className="mt-4">
          <button onClick={() => setPasso(null)}
            className="rounded-xl bg-primary hover:opacity-90 text-white font-semibold px-5 py-2.5">Fechar</button>
        </div>
      </>)}
    </Modal>
  );
}

/** Caixa central simples. Fecha no fundo e no Esc - modal que so fecha no X prende quem so queria olhar. */
function Modal({ children, aoFechar }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") aoFechar(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [aoFechar]);
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={aoFechar}>
      <div className="w-full max-w-lg rounded-2xl bg-white p-5 shadow-xl max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
}

function MeCandidatar({ vagaId, vaga }) {
  const navigate = useNavigate();
  const [mensagem, setMensagem] = useState("");
  const [feito, setFeito] = useState(false);
  const [erro, setErro] = useState(null);
  const [enviando, setEnviando] = useState(false);
  const [interesse, setInteresse] = useState(null); // null | "enviando" | "ok"
  const [narrando, setNarrando] = useState(false);
  const [abrirSkills, setAbrirSkills] = useState(false);
  const [perfil, setPerfil] = useState(undefined); // undefined = carregando
  const [pretensao, setPretensao] = useState("");
  const [pulouPretensao, setPulouPretensao] = useState(false);
  const [salvandoPretensao, setSalvandoPretensao] = useState(false);

  useEffect(() => { obterMeuPerfil().then(setPerfil).catch(() => setPerfil(null)); }, []);

  // CURRÍCULO ANTES DA CANDIDATURA. Sem isso a empresa recebia ficha vazia (telefone, pretensão e skills em
  // branco) de gente que só ia preencher o perfil depois — o candidato parecia fantasma e a vaga parecia mal
  // divulgada. Aqui o pedido é feito ANTES do botão, com o caminho pronto, em vez de barrar no envio.
  // Vale o PDF anexado OU os campos preenchidos — a mesma régua do servidor.
  const temCurriculo = !!perfil && ((perfil.experiencias?.length || 0) > 0 || (perfil.skills?.length || 0) > 0 || !!perfil.temCurriculo);
  // Tem o arquivo mas o perfil está cru: dá para se candidatar, e mesmo assim vale o empurrão — perfil
  // preenchido entra no match das outras vagas, o PDF sozinho não.
  const perfilCru = !!perfil && perfil.temCurriculo && (perfil.experiencias?.length || 0) === 0 && (perfil.skills?.length || 0) === 0;
  // 💰 PRETENSÃO: A EMPRESA PEDE, E A GENTE NÃO PERGUNTAVA A NINGUÉM (23/09/2026).
  //
  // Três candidaturas morreram por isto — Selestine e Joao Paulo na Poli Conecta, Junio na Sinqia.
  // O QuickIn de quem marca `salary` como obrigatório recusa TUDO que não seja número de verdade,
  // e isso foi medido nos três caminhos possíveis, um deles num reenvio real hoje:
  //
  //     salary: 0    → "Must be greater than 1"
  //     salary: ""   → "Must be number"
  //     sem o campo  → "Required field"      ← testado em 23/09, candidatura 198
  //
  // 🚫 Inventar o número está fora de questão, inclusive com média de mercado: pretensão alta demais
  // elimina, baixa demais rebaixa a proposta — e o prejuízo cai sobre quem está procurando emprego.
  // O que faltava não era um valor, era a PERGUNTA.
  //
  // Aqui ela é feita no melhor momento: a pessoa já decidiu se candidatar. E o valor vai para o
  // perfil dela, então responde uma vez e as próximas candidaturas passam direto.
  //
  // ⚠️ NÃO BLOQUEIA. Quem não quiser dizer segue pelo botão normal — e se o ATS recusar, a vaga vira
  // handoff (o worker de saúde cuida disso) e a pessoa vai ao site da empresa. Obrigar a informar
  // salário para se candidatar seria criar um portão nosso, que é o que o portal combate.
  const semPretensao = !!perfil && !perfil.pretensaoClt && !perfil.pretensaoPj;
  const podeIrPorConector = !noSiteDaEmpresa(vaga);
  if (perfil !== undefined && temCurriculo && semPretensao && podeIrPorConector && !pulouPretensao) {
    return (
      <div className="mt-4 rounded-xl border border-sky-200 bg-sky-50 p-4">
        <p className="font-bold text-sky-900">Qual a sua pretensão salarial?</p>
        <p className="text-sm text-sky-800 mt-1">
          Algumas empresas exigem esse campo e <strong>recusam a candidatura sem ele</strong> — é o caso desta.
          Leva cinco segundos e vale para as próximas vagas.
        </p>
        <div className="mt-3 flex flex-wrap items-center gap-2">
          <input type="number" min="1" inputMode="numeric" value={pretensao}
            onChange={(e) => setPretensao(e.target.value)}
            placeholder="R$ por mês"
            className="w-40 rounded-xl border border-sky-300 px-3 py-2 text-sm" />
          <button disabled={salvandoPretensao || !(Number(pretensao) > 1)}
            onClick={async () => {
              setSalvandoPretensao(true);
              try {
                await salvarPerfil({ ...perfil, pretensaoClt: Number(pretensao) });
                setPerfil({ ...perfil, pretensaoClt: Number(pretensao) });
              } catch { setPulouPretensao(true); }   // falha nossa nao pode travar a candidatura dela
              finally { setSalvandoPretensao(false); }
            }}
            className="rounded-xl bg-orange-600 hover:bg-orange-700 disabled:opacity-50 text-white font-semibold px-5 py-2 text-sm">
            {salvandoPretensao ? "Salvando..." : "Salvar e continuar"}
          </button>
          <button onClick={() => setPulouPretensao(true)}
            className="text-sm text-sky-800 underline">
            Prefiro não informar
          </button>
        </div>
        <p className="text-[11px] text-sky-700 mt-2">
          Fica no seu perfil, visível só para a empresa a que você se candidatar.
        </p>
      </div>
    );
  }

  if (perfil !== undefined && !temCurriculo) {
    return (
      <div className="mt-4 rounded-xl border border-amber-200 bg-amber-50 p-4">
        <p className="font-bold text-amber-900">Falta seu currículo para se candidatar</p>
        {/* "Não precisa de PDF" dito AQUI: o texto antigo só falava do PDF, e quem não tem arquivo no celular (o
            público das vagas operacionais) não via caminho — ver o vaivém do Fabiano no CurriculoPage. */}
        <p className="text-sm text-amber-800 mt-1">
          A empresa só consegue avaliar quem mostra o currículo. <strong>Não precisa ter PDF:</strong> basta colocar o
          seu último trabalho (cargo e empresa), leva um minuto. Depois vale para todas as vagas.
        </p>
        <button onClick={() => navigate(`/curriculo?voltar=${encodeURIComponent(window.location.pathname)}`)}
          className="mt-3 rounded-xl bg-orange-600 hover:bg-orange-700 text-white font-semibold px-5 py-2">
          Preencher meu currículo
        </button>
        <p className="text-[11px] text-amber-700 mt-2">Tem o PDF em mãos? Dá para subir o arquivo e a IA preenche os campos para você.</p>
      </div>
    );
  }

  // Aderência ANTES do botão: quem tem perfil distante da vaga fica sabendo agora, não depois de esperar
  // um retorno que não vem. Não bloqueia — a decisão continua sendo da pessoa.
  // O modal fica ANTES do resto: enquanto a cadeia roda, é a única coisa na tela.
  if (narrando) return <ModalEntrega vagaId={vagaId} onFim={() => { setNarrando(false); setFeito(true); }} />;

  const m = vaga?.match;
  // Confirmação forte: é o único momento em que a pessoa tem certeza de que a empresa foi avisada. Discreto
  // demais, vira dúvida — e dúvida aqui faz o candidato ir embora achando que fez algo que não fez.
  if (feito) return (
    <div role="status" className="mt-4 rounded-xl border-2 border-green-300 bg-green-50 p-4">
      <p className="font-bold text-green-900 text-lg">✅ Candidatura enviada!</p>
      <p className="text-sm text-green-800 mt-1">
        A empresa já recebeu um aviso com o seu currículo. Daqui pra frente o eaiRH acompanha o retorno —
        se ele não vier, a gente cobra.
      </p>
      <button onClick={() => navigate("/oportunidades")} className="mt-3 text-sm font-semibold text-green-900 underline">
        Ver outras vagas compatíveis com você
      </button>
    </div>
  );
  const acenar = async () => { setInteresse("enviando"); try { await interesseNaVaga(vagaId, mensagem); setInteresse("ok"); } catch (e) { setErro(e.message); setInteresse(null); } };
  return (
    <div className="mt-4 rounded-xl border border-gray-200 bg-gray-50 p-3">
      {erro && <p role="alert" className="text-red-600 text-sm mb-1">{erro}</p>}
      {/* Era um input de uma linha ao lado do botão — ninguém escrevia nada relevante. Como caixa, o campo
          convida a duas coisas que não cabem no currículo: o diferencial da pessoa e a informação prática
          (aviso prévio, disponibilidade, acessibilidade). O texto vai em destaque no e-mail que a empresa recebe. */}
      <label className="block text-sm font-semibold text-gray-700" htmlFor={`obs-${vagaId}`}>Quer contar algo à empresa? <span className="font-normal text-gray-400">(opcional)</span></label>
      <p className="text-xs text-gray-500 mt-0.5 mb-1.5">
        Um diferencial que não cabe no currículo, o motivo de querer essa vaga — ou algo prático, como disponibilidade, aviso prévio e necessidade de acessibilidade.
      </p>
      <textarea id={`obs-${vagaId}`} value={mensagem} onChange={(e) => setMensagem(e.target.value)} rows="3" maxLength={1000}
        placeholder="Escreva com suas palavras. A empresa lê isso antes de abrir seu currículo."
        className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm mb-2" />
      {typeof m === "number" && (
        <div className={`mb-2 rounded-lg border px-3 py-2 text-xs ${m >= 60 ? "border-green-200 bg-green-50 text-green-800" : m >= 35 ? "border-blue-200 bg-blue-50 text-blue-800" : "border-amber-200 bg-amber-50 text-amber-900"}`}>
          <strong>{m}% de aderência</strong> entre o seu currículo e esta vaga
          {vaga?.matchMotivos?.length > 0 && <> — {vaga.matchMotivos.join(" · ")}</>}
          {/* 🎯 O QUE FALTOU. Até aqui o match mostrava só o que casou ("4/7 skills: Vendas, Excel"): a pessoa via o
              número e não sabia o que estudar para a próxima. A diferença é a única parte do cálculo que ela pode
              mudar — e é também o gancho honesto para sugestão de curso, quando houver. */}
          {vaga?.matchFaltando?.length > 0 && (
            <div className="mt-1.5 pt-1.5 border-t border-current/20">
              <strong>Esta vaga também pede:</strong> {vaga.matchFaltando.join(", ")}
              {/* 25/09/2026: o "quando houver" do comentário acima chegou. Até aqui a tela dizia o que
                  faltava e parava — apontar o buraco sem oferecer saída. O botão abre o mesmo popup do
                  currículo, com onde aprender cada uma (gratuitos primeiro). */}
              <button type="button" onClick={() => setAbrirSkills(true)}
                      className="ml-1.5 font-semibold underline">
                onde aprender?
              </button>
            </div>
          )}
          {m < 35 && (
            <> . Você pode se candidatar mesmo assim, mas vale ver as <button type="button" onClick={() => navigate("/oportunidades")} className="font-semibold underline">vagas mais compatíveis com você</button>.</>
          )}
        </div>
      )}
      {perfilCru && (
        <p className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 mb-2">
          Seu currículo em PDF está anexado e a empresa vai recebê-lo. Mas seu perfil está sem skills e sem
          experiência — sem isso você <strong>não aparece</strong> nas buscas das empresas nem no match das outras vagas.
          <button type="button" onClick={() => navigate(`/curriculo?voltar=${encodeURIComponent(window.location.pathname)}`)} className="ml-1 font-semibold underline">Completar agora</button>
        </p>
      )}
      <div className="flex flex-wrap gap-2 items-center">
        <button disabled={enviando}
          onClick={async () => { if (enviando) return; setEnviando(true); try { await candidatarVaga(vagaId, mensagem); setNarrando(true); }
            // `jaCandidatado`: a candidatura EXISTE (o servidor recusou a segunda gravacao). Acontece quando o
            // app pool e reciclado no meio do POST e o front repete — ver api.js/`repetivel`. Mostrar erro aqui
            // seria mentir para quem ja esta candidatado, e ainda faria a pessoa tentar de novo. 21/09/2026.
            catch (e) { if (e?.jaCandidatado) { setNarrando(true); return; } setErro(e.message); setEnviando(false); } }}
          className="rounded-xl bg-orange-600 hover:bg-orange-700 disabled:opacity-60 text-white font-semibold px-5 py-2">{enviando ? "Enviando..." : "Me candidatar"}</button>
        {interesse === "ok"
          ? <span className="text-green-700 text-sm font-semibold">Interesse enviado ✓</span>
          : <button type="button" disabled={interesse === "enviando"} onClick={acenar}
              className="rounded-xl border border-primary/40 text-primary disabled:opacity-60 font-semibold px-4 py-2 text-sm hover:bg-primary/5">{interesse === "enviando" ? "..." : "Tenho interesse"}</button>}
      </div>
      <p className="text-[11px] text-gray-400 mt-1"><strong>Me candidatar</strong> envia seu currículo. <strong>Tenho interesse</strong> é um aceno leve: avisa a empresa que você curtiu a vaga, sem candidatura formal.</p>

      {/* 🚫 NÃO ABRE SOZINHO. Quem está aqui veio para se candidatar — desviar para curso no meio disso
          vira obstáculo, não ajuda. Só abre se a pessoa clicar em "onde aprender?" no bloco do match. */}
      <MelhorarSkills aberto={abrirSkills} onFechar={() => setAbrirSkills(false)} />
    </div>
  );
}

/* ══════════════════════════════════════════════════════════════════════════════
 * 📨 O MODAL QUE NARRA A CADEIA — ideia do Nelson em 08/09/2026.
 *
 * ANTES: a pessoa clicava, via "✅ Candidatura enviada!" na hora, e horas depois (às vezes nunca)
 * descobria que não tinha chegado. Em um único dia, três candidaturas reais morreram assim — Vinícius,
 * Caio e Karen — cada uma numa conta de ATS com uma exigência diferente.
 *
 * AGORA: o modal mostra a cadeia acontecendo, degrau a degrau:
 *     1. sistema da empresa (ATS)  →  2. e-mail do processo  →  3. site da empresa
 *
 * 🚫 O CANDIDATO NUNCA VÊ O ERRO TÉCNICO. Nada de "400 ValidationError: salary must be greater than 1".
 * Ele vê o FATO ("esta empresa pede dados que você ainda não preencheu") e o que fazer a respeito.
 * Ver [[eairh-nao-expor-falha-tecnica]].
 *
 * ⚠️ POR QUE POLLING: a entrega roda num escopo de fundo logo após a candidatura ser criada. Reescrever
 * isso para rodar dentro da requisição mexeria no caminho mais crítico do produto. O modal LÊ o estado
 * real (/estado-entrega) — a narração é verdadeira sem ser arriscada.
 *
 * ⏱️ Desiste em ~20s e mostra o desfecho neutro: melhor "estamos enviando, avisamos por e-mail" do que
 * girar para sempre. O servidor continua tentando de qualquer jeito.
 * ══════════════════════════════════════════════════════════════════════════════ */
function ModalEntrega({ vagaId, onFim }) {
  const navigate = useNavigate();
  const [etapa, setEtapa] = useState("tentando");
  const [dados, setDados] = useState(null);
  const [desistiu, setDesistiu] = useState(false);
  // Depois de mandar a pessoa ao site da empresa, o modal NÃO fecha: ele espera a volta dela.
  const [voltou, setVoltou] = useState(null);   // null | "perguntando" | "sim" | "nao"
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    let vivo = true, tentativas = 0;
    const bater = async () => {
      try {
        const r = await estadoEntrega(vagaId);
        if (!vivo) return;
        setDados(r);
        if (r.etapa && r.etapa !== "tentando") { setEtapa(r.etapa); return; }
      } catch { /* ainda não existe: segue tentando */ }
      if (!vivo) return;
      if (++tentativas > 13) { setDesistiu(true); return; }   // ~20s
      setTimeout(bater, 1500);
    };
    bater();
    return () => { vivo = false; };
  }, [vagaId]);

  const resolvido = etapa !== "tentando";
  // Cada degrau tem três estados: esperando (cinza), rodando (spinner) e resolvido (✓ ou —).
  const situacao = (passo) => {
    if (!resolvido) return passo === "ats" ? "ativo" : "espera";
    const ordem = { ats: 1, email: 2, link: 3 };
    if (ordem[passo] < ordem[etapa]) return "pulou";
    if (passo === etapa) return "ok";
    return "espera";
  };

  // 🚨 A FRASE MUDA CONFORME DE QUEM É A FALTA. Nelson testou com o perfil completo e leu "complete seu
  // perfil" porque a vaga exigia perguntas próprias — culpa dele por um portão da empresa. Ver `deQuem`.
  const faltouPerfil = dados?.deQuem === "perfil";
  const NOTA = {
    ats:   { ok: "Sua candidatura entrou no sistema deles.",
             pulou: faltouPerfil
               ? "Esta empresa pede dados que você ainda não preencheu."
               : "Esta empresa não aceita candidatura enviada de fora do site dela." },
    email: { ok: "Enviada para quem cuida deste processo.",  pulou: "O anúncio não publicou e-mail de contato." },
    link:  { ok: "Vamos te levar até lá.",                   pulou: "" },
  };

  const Degrau = ({ passo, texto }) => {
    const st = situacao(passo);
    const cor = st === "ok" ? "border-green-600 bg-green-600 text-white"
      : st === "ativo" ? "border-primary text-primary"
      : st === "pulou" ? "border-gray-300 border-dashed text-gray-400" : "border-gray-200 text-gray-400";
    return (
      <li className="grid grid-cols-[26px_1fr] gap-3 items-start py-2">
        <span className={`w-[26px] h-[26px] rounded-full border-2 grid place-items-center text-xs font-bold ${cor}`}>
          {st === "ok" ? "✓" : st === "pulou" ? "—" : st === "ativo"
            ? <span className="w-3 h-3 rounded-full border-2 border-primary/30 border-t-primary animate-spin" />
            : { ats: "1", email: "2", link: "3" }[passo]}
        </span>
        <span className={`text-sm font-semibold pt-0.5 ${st === "espera" ? "text-gray-400" : "text-gray-800"} ${st === "pulou" ? "line-through decoration-gray-400" : ""}`}>
          {texto}
          {(st === "ok" || st === "pulou") && NOTA[passo][st] && (
            <span className="block text-xs font-normal text-gray-500 mt-0.5 no-underline">{NOTA[passo][st]}</span>
          )}
        </span>
      </li>
    );
  };

  const DESFECHO = {
    ats:   { tit: "Candidatura enviada", cor: "border-green-300 bg-green-50",
             txt: "Ela entrou direto no sistema onde a recrutadora trabalha. O eaiRH acompanha o retorno e, se não vier, cobra." },
    email: { tit: "Candidatura enviada por e-mail", cor: "border-green-300 bg-green-50",
             txt: faltouPerfil
               ? "Foi para o responsável pelo processo, com seu currículo anexado. Completando seu perfil, na próxima ela entra direto no sistema da empresa."
               : "Foi para o responsável pelo processo, com seu currículo anexado. O eaiRH continua acompanhando o retorno." },
    link:  { tit: "Esta empresa recebe só no site dela", cor: "border-amber-300 bg-amber-50",
             txt: "Abra a página para se candidatar lá. Quando terminar, volte e nos conte — é assim que a gente consegue cobrar o retorno dela." },
  };
  const d = DESFECHO[etapa];

  return (
    <div className="fixed inset-0 z-50 bg-primary/40 grid place-items-center p-4" role="dialog" aria-modal="true">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6">
        <h3 className="font-bold text-lg text-primary">{resolvido && d ? d.tit : "Enviando sua candidatura"}</h3>
        {!resolvido && !desistiu && <p className="text-sm text-gray-500 mt-1">Isso leva alguns segundos. Não feche esta janela.</p>}

        <ul className="list-none m-0 p-0 mt-4">
          <Degrau passo="ats" texto="Enviando pelo sistema da empresa" />
          <Degrau passo="email" texto="Procurando o e-mail do processo" />
          <Degrau passo="link" texto="Abrindo o site da empresa" />
        </ul>

        {desistiu && !resolvido && (
          <div className="mt-4 rounded-xl border border-gray-200 bg-gray-50 p-4">
            <p className="font-bold text-gray-800 text-sm">Ainda estamos enviando</p>
            <p className="text-sm text-gray-600 mt-1">Está demorando mais que o normal. Pode fechar: assim que sair, você recebe um e-mail.</p>
          </div>
        )}

        {resolvido && d && voltou === null && (
          <div className={`mt-4 rounded-xl border p-4 ${d.cor}`}>
            <p className="font-bold text-sm text-gray-900">{d.tit}</p>
            <p className="text-sm text-gray-700 mt-1">{d.txt}</p>
          </div>
        )}

        {/* A VOLTA. "Não consegui" vale tanto quanto "sim": é porta quebrada do lado da empresa, e é
            informação que ninguém mais no mercado coleta. */}
        {voltou === "perguntando" && (
          <div className="mt-4 rounded-xl border border-primary/30 bg-primary/5 p-4">
            <p className="font-bold text-sm text-gray-900">Conseguiu se candidatar por lá?</p>
            <p className="text-sm text-gray-600 mt-1">
              É com a sua resposta que a gente passa a acompanhar este processo e cobrar retorno da empresa.
            </p>
            <div className="flex flex-wrap gap-2 mt-3">
              <button disabled={salvando}
                onClick={async () => {
                  setSalvando(true);
                  try { await declararCandidatura(vagaId, { naoConsegui: false }); } catch { /* a resposta dela vale mais que o registro */ }
                  setVoltou("sim");
                }}
                className="rounded-xl bg-green-600 hover:bg-green-700 disabled:opacity-60 text-white font-semibold px-5 py-2.5 text-sm">
                Consegui, me candidatei
              </button>
              <button disabled={salvando}
                onClick={async () => {
                  setSalvando(true);
                  try { await declararCandidatura(vagaId, { naoConsegui: true }); } catch { /* idem */ }
                  setVoltou("nao");
                }}
                className="rounded-xl border border-gray-300 text-gray-700 hover:bg-gray-50 disabled:opacity-60 font-semibold px-5 py-2.5 text-sm">
                Não consegui
              </button>
            </div>
          </div>
        )}

        {voltou === "sim" && (
          <div className="mt-4 rounded-xl border border-green-300 bg-green-50 p-4">
            <p className="font-bold text-sm text-gray-900">Anotado. Agora é com a gente.</p>
            <p className="text-sm text-gray-700 mt-1">
              O eaiRH vai acompanhar este processo. Se a empresa não der retorno, nós cobramos.
            </p>
            <button onClick={onFim} className="mt-3 rounded-xl bg-orange-600 hover:bg-orange-700 text-white font-semibold px-5 py-2.5 text-sm">Fechar</button>
          </div>
        )}

        {voltou === "nao" && (
          <div className="mt-4 rounded-xl border border-amber-300 bg-amber-50 p-4">
            <p className="font-bold text-sm text-gray-900">Obrigado por contar. O que aconteceu?</p>
            <p className="text-xs text-gray-600 mt-1">
              Não é relato público e não vai para a empresa: é só para a gente entender onde o caminho trava.
            </p>
            <MotivoRapido vagaId={vagaId} />
            {/* 🚨 O "FECHAR" ROUBAVA O CLIQUE (23/09/2026).
                Medido: de 33 pessoas que disseram "não consegui", 24 (73%) não informaram o motivo — e
                o campo de texto livre está vazio em TODAS, desde sempre.
                A causa é de desenho, não de má vontade: este botão era laranja, grande, a cor de ação
                principal do site, ao lado de botõezinhos cinza. Visualmente ele ERA o passo seguinte.
                Agora os motivos ficam com o peso da ação e a saída é um link discreto — e o rótulo
                honesto ("prefiro não dizer") reconhece a escolha em vez de parecer o caminho natural.
                🚫 Continua sem bloquear: o "não consegui" já foi registrado no clique anterior. */}
            <button onClick={onFim}
              className="mt-3 block text-xs text-gray-500 underline hover:text-gray-700">
              prefiro não dizer
            </button>
          </div>
        )}

        <div className="flex flex-wrap gap-2 mt-4">
          {/* 🚨 O LINK NÃO ENCERRA A CONVERSA — ele começa a parte que sustenta o produto.
              Mandar a pessoa embora e fechar o modal seria trocar "candidatura que some" por "candidatura
              que some com mais passos": sem a volta dela, o eaiRH não sabe que o processo existe e não
              tem o que cobrar da empresa. Hoje só 18% confirmam (2 de 11), e é justamente por isso que a
              pergunta tem de estar aqui, no segundo em que ela volta — não num e-mail horas depois. */}
          {etapa === "link" && dados?.urlExterna && voltou === null && (
            <a href={dados.urlExterna} target="_blank" rel="noopener noreferrer"
               onClick={() => {
                 setVoltou("perguntando");
                 // Registra a IDA sem esperar resposta: quem abre e some seria invisível, e o funil
                 // vazaria em silêncio no passo que nós mesmos criamos.
                 declararCandidatura(vagaId, { abriu: true }).catch(() => {});
               }}
               className="rounded-xl bg-orange-600 hover:bg-orange-700 text-white font-semibold px-5 py-2.5 text-sm">
              Ir para o site da empresa
            </a>
          )}
          {/* Só oferece completar o perfil quando é ISSO que resolve. Quando o portão é da empresa,
              mandar a pessoa mexer num perfil que já está certo é perder a confiança dela à toa. */}
          {etapa === "email" && faltouPerfil && (
            <button onClick={() => navigate(`/curriculo?voltar=${encodeURIComponent(window.location.pathname)}`)}
              className="rounded-xl bg-orange-600 hover:bg-orange-700 text-white font-semibold px-5 py-2.5 text-sm">
              Completar meu perfil
            </button>
          )}
          {(etapa !== "link" || voltou === null) && (
            <button onClick={onFim}
              className={`rounded-xl font-semibold px-5 py-2.5 text-sm ${etapa === "ats" ? "bg-orange-600 hover:bg-orange-700 text-white" : "border border-gray-300 text-gray-600 hover:bg-gray-50"}`}>
              Fechar
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

function MudarStatus({ vaga, onOk }) {
  const [erro, setErro] = useState(null);
  return (
    <div className="mt-4 flex items-center gap-2 text-sm">
      <span className="font-semibold text-gray-600">Status da vaga:</span>
      <select aria-label="Alterar status da vaga" value={vaga.status} onChange={async (e) => { try { await alterarStatusVaga(vaga.id, Number(e.target.value)); onOk(); } catch (er) { setErro(er.message); } }}
        className="rounded-lg border border-gray-300 px-2.5 py-1.5 outline-none focus:ring-2 focus:ring-primary">
        {/* Expirada (4) não é escolha manual — mostra como opção desabilitada só p/ refletir o estado atual da vaga encerrada por inatividade. */}
        {vaga.status === 4 && <option value={4} disabled>Encerrada por inatividade</option>}
        {STATUS_VAGA.map((s) => <option key={s.v} value={s.v}>{s.t}</option>)}
      </select>
      {erro && <span className="text-red-600 text-xs">{erro}</span>}
    </div>
  );
}

// Fechamento cordial da vaga: o diferencial. A empresa marca a vaga como preenchida e a plataforma avisa,
// com transparência, TODOS os candidatos — parabéns ao contratado (opcional) + agradecimento aos demais —
// com mensagens que a própria empresa personaliza e pelos canais que ela escolher (e-mail/WhatsApp).
const MSG_CONTRATADO_PADRAO = "<p><strong>Parabéns, {nome}! 🎉</strong></p><p>Que alegria te contar que você foi selecionado(a) para a vaga de <strong>{vaga}</strong> na {empresa}. Em breve entramos em contato com os próximos passos.</p><p>Seja muito bem-vindo(a)! 🙌</p>";
const MSG_DEMAIS_PADRAO = "<p>Oi, {nome}!</p><p>Passando pra te contar, com transparência, que a vaga de <strong>{vaga}</strong> na {empresa} foi preenchida. Sei que não é a notícia que você esperava — mas queria muito agradecer pelo seu tempo e interesse.</p><p>Você segue no nosso radar pras próximas oportunidades. Obrigado por ter participado! 💙</p>";

// Campo de mensagem do encerramento: escolhe entre os modelos salvos da empresa, edita e pode salvar o texto
// atual como modelo novo (que passa a vir preenchido nas próximas vagas).
function CampoModelo({ tipo, rotulo, ta, valor, setValor, valorWpp, setValorWpp, modelos, onSalvar, salvando }) {
  const doTipo = (modelos || []).filter((m) => m.tipo === tipo);
  const tags = tipo === 2 ? [...TAGS_ENCERRAMENTO, "{motivo}"] : TAGS_ENCERRAMENTO;
  const [rev, setRev] = useState(0); // força o editor visual a recarregar quando troca de modelo
  return (
    <div className="text-sm">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span className="font-semibold text-gray-700">{rotulo}</span>
        <button type="button" onClick={() => onSalvar(tipo)} disabled={salvando}
          className="text-xs font-semibold text-primary hover:underline disabled:opacity-50">
          {salvando ? "Salvando…" : "💾 Salvar como meu modelo"}
        </button>
      </div>
      {/* Régua da Lilian (RH que também é candidata, 06/08): o candidato espera posicionamento, não feedback detalhado. */}
      <p className="mt-0.5 text-xs text-gray-500">
        Curto e verdadeiro vale mais que longo — quem participou espera um <strong>posicionamento</strong>, não um feedback detalhado.
      </p>
      {doTipo.length > 0 && (
        <select onChange={(e) => {
            const m = doTipo.find((x) => String(x.id) === e.target.value);
            if (m) { setValor(m.corpo); setValorWpp(m.corpoWhatsapp || ""); setRev((r) => r + 1); }
          }}
          defaultValue="" className={ta + " mt-1 bg-gray-50"}>
          <option value="">Usar um modelo salvo…</option>
          {doTipo.map((m) => <option key={m.id} value={m.id}>{m.nome}{m.padrao ? " (padrão)" : ""}</option>)}
        </select>
      )}
      <div className="mt-1">
        <span className="block text-xs text-gray-500 mb-1">✉️ E-mail</span>
        <HtmlEditor key={`h-${tipo}-${rev}`} initialHtml={valor} onChange={setValor} tags={tags} />
      </div>
      <div className="mt-2">
        <span className="block text-xs text-gray-500 mb-1">💬 WhatsApp <span className="text-gray-400">(opcional — em branco, mandamos o mesmo recado em texto)</span></span>
        <WhatsappEditor value={valorWpp} onChange={setValorWpp} tags={tags} rows={4} placeholder="Oi, {nome}! ..." />
      </div>
    </div>
  );
}

// Texto do encerramento SEM contratação — a tag {motivo} completa a frase com o motivo escolhido na hora.
const MSG_SEM_CONTRATACAO_PADRAO = "<p>Oi, {nome}!</p><p>Preciso te contar que o processo da vaga de <strong>{vaga}</strong> na {empresa} foi encerrado — {motivo}. Não seguimos com nenhum candidato desta vez.</p><p>Agradeço de verdade pelo seu tempo e interesse, e você fica no nosso radar para as próximas oportunidades. 💙</p>";

function FecharVaga({ vaga, onOk }) {
  const [aberto, setAberto] = useState(false);
  const [lista, setLista] = useState(null); // candidaturas p/ escolher o contratado
  const [contratado, setContratado] = useState(""); // usuarioId ("" = não informar)
  const [semContratacao, setSemContratacao] = useState(false); // "como esta vaga terminou?"
  const [msgContratado, setMsgContratado] = useState(MSG_CONTRATADO_PADRAO);
  const [msgDemais, setMsgDemais] = useState(MSG_DEMAIS_PADRAO);
  const [msgSemContratacao, setMsgSemContratacao] = useState(MSG_SEM_CONTRATACAO_PADRAO);
  const [wppContratado, setWppContratado] = useState("");
  const [wppDemais, setWppDemais] = useState("");
  const [wppSemContratacao, setWppSemContratacao] = useState("");
  const [motivo, setMotivo] = useState(""); // texto que substitui {motivo} ("" = prefiro não informar)
  const [modelos, setModelos] = useState([]);   // modelos salvos pela empresa
  const [motivosEmpresa, setMotivosEmpresa] = useState([]);
  const [salvandoModelo, setSalvandoModelo] = useState(null); // tipo sendo salvo como modelo
  const [porEmail, setPorEmail] = useState(true);
  const [porWhatsapp, setPorWhatsapp] = useState(true);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState(null);
  const [ok, setOk] = useState(null);

  useEffect(() => {
    if (aberto && lista === null) candidaturasDaVaga(vaga.id).then(setLista).catch(() => setLista([]));
  }, [aberto, lista, vaga.id]);

  // Carrega os modelos e motivos da empresa e já preenche cada campo com o modelo PADRÃO dela (se houver).
  useEffect(() => {
    if (!aberto) return;
    modelosEncerramento().then((ms) => {
      setModelos(ms || []);
      const padrao = (t) => (ms || []).find((m) => m.tipo === t && m.padrao);
      if (padrao(0)) { setMsgContratado(padrao(0).corpo); setWppContratado(padrao(0).corpoWhatsapp || ""); }
      if (padrao(1)) { setMsgDemais(padrao(1).corpo); setWppDemais(padrao(1).corpoWhatsapp || ""); }
      if (padrao(2)) { setMsgSemContratacao(padrao(2).corpo); setWppSemContratacao(padrao(2).corpoWhatsapp || ""); }
    }).catch(() => {});
    motivosEncerramento().then((m) => setMotivosEmpresa(m || [])).catch(() => {});
  }, [aberto]);

  const corpoDoTipo = (t) => (t === 0 ? msgContratado : t === 1 ? msgDemais : msgSemContratacao);
  const wppDoTipo = (t) => (t === 0 ? wppContratado : t === 1 ? wppDemais : wppSemContratacao);

  // "Salvar como meu modelo": guarda o texto escrito agora para reusar nas próximas vagas.
  const salvarComoModelo = async (tipo) => {
    const corpo = corpoDoTipo(tipo);
    if (!corpo.trim()) return;
    const nome = window.prompt("Nome deste modelo (ex.: Padrão carinhoso):", "Meu modelo");
    if (!nome) return;
    setSalvandoModelo(tipo); setErro(null);
    try {
      const novo = await criarModeloEncerramento({ tipo, nome, corpo, corpoWhatsapp: wppDoTipo(tipo) || null, padrao: true });
      setModelos((ms) => [...ms.map((m) => (m.tipo === tipo ? { ...m, padrao: false } : m)), novo]);
      setOk("Modelo salvo — já vem preenchido nas próximas vagas.");
      setTimeout(() => setOk(null), 3000);
    } catch (e) { setErro(e.message); }
    setSalvandoModelo(null);
  };

  const enviar = async () => {
    if (enviando) return; // anti-duplo-clique (backend também é idempotente por status Finalizada)
    if (!porEmail && !porWhatsapp) { setErro("Escolha ao menos um canal (e-mail ou WhatsApp)."); return; }
    const corpoDemais = semContratacao ? msgSemContratacao : msgDemais;
    if (!corpoDemais.trim()) { setErro("Escreva a mensagem para os candidatos."); return; }
    setErro(null); setEnviando(true);
    try {
      const r = await encerrarVaga(vaga.id, {
        contratadoUsuarioId: !semContratacao && contratado ? Number(contratado) : null,
        msgContratado, msgDemais: corpoDemais, porEmail, porWhatsapp,
        semContratacao, motivo: semContratacao ? motivo : null,
        msgContratadoWhatsapp: wppContratado || null,
        msgDemaisWhatsapp: (semContratacao ? wppSemContratacao : wppDemais) || null,
      });
      const extras = r.avisadosInteressados > 0 ? ` + ${r.avisadosInteressados} interessado(s)` : "";
      setOk(`Vaga encerrada ✓ ${r.avisadosDemais} candidato(s) avisado(s)${extras}${r.contratadoAvisado ? " + parabéns enviado ao contratado" : ""}.`);
      setTimeout(() => { setAberto(false); onOk(); }, 2000);
    } catch (e) { setErro(e.message); setEnviando(false); }
  };

  if (vaga.status === 3) return <p className="mt-3 text-sm text-gray-500">✅ Vaga encerrada — os candidatos já foram avisados com cordialidade.</p>;

  const ta = "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary";
  return (
    <div className="mt-4">
      {!aberto ? (
        <button onClick={() => setAberto(true)} className="rounded-xl bg-green-600 hover:bg-green-700 text-white font-semibold px-5 py-2 text-sm">
          ✅ Encerrar vaga com fechamento cordial
        </button>
      ) : (
        <div className="rounded-2xl border border-green-200 bg-green-50/40 p-4 space-y-3">
          <div>
            <h3 className="font-bold text-gray-900">Fechamento cordial da vaga</h3>
            <p className="text-xs text-gray-500">Ao encerrar, avisamos os candidatos com transparência — ninguém fica no vácuo. Você personaliza as mensagens e escolhe os canais.</p>
          </div>

          {/* Como a vaga terminou define TUDO o que aparece abaixo — e impede a mensagem de afirmar
              "a vaga foi preenchida" quando na verdade ela foi cancelada ou congelada. */}
          <fieldset className="rounded-xl border border-gray-200 bg-white p-3">
            <legend className="px-1 text-sm font-semibold text-gray-700">Como esta vaga terminou?</legend>
            <label className="flex items-center gap-2 text-sm">
              <input type="radio" checked={!semContratacao} onChange={() => setSemContratacao(false)} />
              Contratamos alguém
            </label>
            <label className="flex items-center gap-2 text-sm mt-1">
              <input type="radio" checked={semContratacao} onChange={() => setSemContratacao(true)} />
              Encerrada sem contratação
            </label>
          </fieldset>

          {!semContratacao && (
            <>
              <label className="block text-sm">
                <span className="font-semibold text-gray-700">Quem foi contratado? <span className="font-normal text-gray-400">(opcional)</span></span>
                <select value={contratado} onChange={(e) => setContratado(e.target.value)} className={ta + " mt-1"}>
                  <option value="">Não informar / contratei por fora</option>
                  {(lista || []).map((c) => <option key={c.usuarioId} value={c.usuarioId}>{c.nome}</option>)}
                </select>
              </label>

              {contratado && (
                <CampoModelo tipo={0} rotulo="📗 Mensagem para o aprovado" ta={ta}
                  valor={msgContratado} setValor={setMsgContratado}
                  valorWpp={wppContratado} setValorWpp={setWppContratado} modelos={modelos}
                  onSalvar={salvarComoModelo} salvando={salvandoModelo === 0} />
              )}

              <CampoModelo tipo={1} rotulo="📘 Mensagem para os não aprovados" ta={ta}
                valor={msgDemais} setValor={setMsgDemais}
                valorWpp={wppDemais} setValorWpp={setWppDemais} modelos={modelos}
                onSalvar={salvarComoModelo} salvando={salvandoModelo === 1} />
            </>
          )}

          {semContratacao && (
            <>
              <label className="block text-sm">
                <span className="font-semibold text-gray-700">Por que a vaga foi encerrada?</span>
                <select value={motivo} onChange={(e) => setMotivo(e.target.value)} className={ta + " mt-1"}>
                  <option value="">Prefiro não informar</option>
                  {MOTIVOS_ENCERRAMENTO_PADRAO.map((m) => <option key={m.rotulo} value={m.texto}>{m.rotulo}</option>)}
                  {motivosEmpresa.map((m) => <option key={m.id} value={m.texto}>{m.rotulo}</option>)}
                </select>
                <span className="mt-1 block text-[11px] text-gray-400">
                  {motivo
                    ? "Aparece na mensagem (no lugar de {motivo}) e na página da vaga encerrada."
                    : "Sem motivo informado, nada aparece na página da vaga — e a mensagem usa uma frase neutra."}
                </span>
              </label>

              <CampoModelo tipo={2} rotulo="📙 Mensagem para todos os candidatos" ta={ta}
                valor={msgSemContratacao} setValor={setMsgSemContratacao}
                valorWpp={wppSemContratacao} setValorWpp={setWppSemContratacao} modelos={modelos}
                onSalvar={salvarComoModelo} salvando={salvandoModelo === 2} />
            </>
          )}

          <p className="text-[11px] text-gray-400">
            Use <code className="bg-gray-100 px-1 rounded">{"{nome}"}</code>, <code className="bg-gray-100 px-1 rounded">{"{vaga}"}</code> e <code className="bg-gray-100 px-1 rounded">{"{empresa}"}</code>
            {semContratacao && <> e <code className="bg-gray-100 px-1 rounded">{"{motivo}"}</code></>} — trocamos pelos dados reais de cada candidato.
          </p>

          <div className="flex flex-wrap items-center gap-4 text-sm">
            <span className="font-semibold text-gray-700">Enviar por:</span>
            <label className="flex items-center gap-1.5"><input type="checkbox" checked={porEmail} onChange={(e) => setPorEmail(e.target.checked)} /> E-mail</label>
            <label className="flex items-center gap-1.5"><input type="checkbox" checked={porWhatsapp} onChange={(e) => setPorWhatsapp(e.target.checked)} /> WhatsApp</label>
            <span className="text-[11px] text-gray-400">(só chega no canal que o candidato autorizou)</span>
          </div>

          {erro && <p role="alert" className="text-red-600 text-sm">{erro}</p>}
          {ok && <p role="status" className="text-green-700 text-sm font-semibold">{ok}</p>}

          <div className="flex gap-2">
            <button onClick={enviar} disabled={enviando || !!ok} className="rounded-xl bg-green-600 hover:bg-green-700 disabled:opacity-60 text-white font-semibold px-5 py-2 text-sm">
              {enviando ? "Encerrando..." : "Encerrar e avisar candidatos"}
            </button>
            {!ok && <button onClick={() => setAberto(false)} className="rounded-xl border border-gray-300 text-gray-600 font-semibold px-4 py-2 text-sm hover:bg-gray-50">Cancelar</button>}
          </div>
        </div>
      )}
    </div>
  );
}

// Pretensão para exibição: vazio vira "não informado" (nunca R$ 0), igual ao e-mail que a empresa recebe.
const fmtPretensao = (v) => v == null || Number(v) <= 0 ? null : `R$ ${Number(v).toLocaleString("pt-BR", { maximumFractionDigits: 0 })}`;
const soDigitos = (s) => (s || "").replace(/\D/g, "");

function CandidaturasRecebidas({ vagaId, vagaTitulo, vaga, foco, onQtd }) {
  const [emailPara, setEmailPara] = useState(null); // candidato do modal "Enviar e-mail"
  const [lista, setLista] = useState(null);
  const [erro, setErro] = useState(null);
  const [baixando, setBaixando] = useState(null); // usuarioId em download
  const [perfilAberto, setPerfilAberto] = useState(null);
  const [marcando, setMarcando] = useState(null);
  // Devolve a quantidade ao pai para o número aparecer NA ABA: sem isso a empresa teria de trocar de aba só
  // para descobrir se há alguém esperando — e o que exige clique para descobrir acaba não sendo olhado.
  useEffect(() => {
    candidaturasDaVaga(vagaId)
      .then((l) => { setLista(l); onQtd?.(l.length); })
      .catch(() => { setLista([]); onQtd?.(0); });
  }, [vagaId, onQtd]);

  // Chegou pelo link do e-mail (?candidato=): rola até o card e abre o perfil completo. Sem isso o recrutador
  // caía no topo da página e tinha que procurar, na mão, a pessoa que o próprio aviso já nomeava.
  useEffect(() => {
    if (!foco || !lista?.length) return;
    const alvo = lista.find((c) => c.usuarioId === foco);
    if (!alvo) return;
    setPerfilAberto(alvo);
    document.getElementById(`cand-${foco}`)?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [foco, lista]);

  if (!lista || lista.length === 0) return null;

  const marcarRespondido = async (uid) => {
    setErro(null); setMarcando(uid);
    try {
      const r = await registrarRetornoExterno(vagaId, uid);
      setLista((l) => l.map((x) => (x.usuarioId === uid ? { ...x, retornoEm: r.retornoEm, retornoForaDaPlataforma: true } : x)));
    } catch (e) { setErro(e.message); }
    finally { setMarcando(null); }
  };

  const baixar = async (uid) => {
    setErro(null); setBaixando(uid);
    try { await baixarCurriculoCandidato(uid); } catch (e) { setErro(e.message); }
    finally { setBaixando(null); }
  };

  const baixarPadrao = async (uid) => {
    setErro(null); setBaixando(`p${uid}`);
    try { await baixarCurriculoPadrao(uid); } catch (e) { setErro(e.message); }
    finally { setBaixando(null); }
  };

  return (
    <section className="mt-6">
      <h2 className="text-xl font-bold text-gray-900 mb-3">Candidaturas recebidas ({lista.length})</h2>
      {erro && <p role="alert" className="text-red-600 text-sm mb-2">{erro}</p>}
      <div className="space-y-2">
        {lista.map((c) => {
          const clt = fmtPretensao(c.pretensaoClt), pj = fmtPretensao(c.pretensaoPj);
          const zap = soDigitos(c.whatsapp);
          return (
            <div key={c.usuarioId} id={`cand-${c.usuarioId}`}
              className={`rounded-xl border bg-white p-3 shadow-sm ${foco === c.usuarioId ? "border-primary ring-2 ring-primary/30" : "border-gray-200"}`}>
              <div className="flex flex-wrap items-start gap-3">
                <span className={`font-bold rounded-full px-2.5 py-1 text-xs ${corMatch(c.match)}`}>{c.match}%</span>
                <div className="flex-1 min-w-[200px]">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="font-semibold text-gray-900">{c.nome}</span>
                    {/* Etapa lida no sistema da PRÓPRIA empresa, com o nome que ela usa lá dentro. Vai crua aqui
                        de propósito: quem lê esta tela é quem conduz o processo, e traduzir seria esconder dela o
                        próprio dado. A tradução existe só do lado do candidato, onde o nome interno não pode
                        aparecer. Etapa final ganha cor de alerta quando ainda não há retorno registrado — é a
                        pessoa que está esperando uma resposta que já existe. */}
                    {c.etapa && (
                      <span title={c.etapaEm ? `No sistema de vocês desde ${new Date(c.etapaEm).toLocaleDateString("pt-BR")}` : undefined}
                        className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${
                          c.etapaFinal && !c.retornoEm ? "bg-amber-100 text-amber-900"
                          : c.etapaFinal ? "bg-gray-100 text-gray-600" : "bg-blue-50 text-blue-800"}`}>
                        {c.etapa}
                        {c.etapaEm && <> · {new Date(c.etapaEm).toLocaleDateString("pt-BR")}</>}
                      </span>
                    )}
                  </div>
                  <div className="text-xs text-gray-500">
                    {[c.headline, c.senioridade, c.cidade].filter(Boolean).join(" · ")}
                  </div>
                  {c.etapaFinal && !c.retornoEm && (
                    <div className="text-xs text-amber-800 mt-1">
                      Este processo já está encerrado no seu sistema e a pessoa ainda não recebeu retorno.
                    </div>
                  )}
                  {c.mensagem && <div className="text-sm text-gray-600 mt-1 border-l-2 border-primary/40 pl-2 italic">"{c.mensagem}"</div>}
                  {/* O contato aparece porque a pessoa se candidatou a ESTA vaga — ela veio até a empresa. */}
                  <div className="text-xs text-gray-500 mt-1.5 flex flex-wrap gap-x-3 gap-y-0.5">
                    {c.email && <span>📧 {c.email}</span>}
                    <span>📱 {c.whatsapp || <em className="text-gray-400">não informado</em>}</span>
                    <span>💰 CLT: {clt || <em className="text-gray-400">não informado</em>}</span>
                    <span>PJ: {pj || <em className="text-gray-400">não informado</em>}</span>
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap gap-2 mt-2">
                {/* DOIS currículos, de propósito: o "padrão eaiRH" sai dos dados do perfil, sempre no mesmo
                    layout (comparável entre candidatos); o anexo é o arquivo que a pessoa subiu, em qualquer
                    formato. Antes só existia o anexo, e o padrão que montamos não chegava à empresa. */}
                <button type="button" onClick={() => baixarPadrao(c.usuarioId)} disabled={baixando === `p${c.usuarioId}`}
                  className="rounded-lg border border-primary/40 px-3 py-1.5 text-xs font-semibold text-primary hover:bg-primary/5 disabled:opacity-60">
                  {baixando === `p${c.usuarioId}` ? "Gerando..." : "📄 Currículo padrão eaiRH"}</button>
                {c.temCurriculo
                  ? <button type="button" onClick={() => baixar(c.usuarioId)} disabled={baixando === c.usuarioId}
                      className="rounded-lg border border-gray-300 px-3 py-1.5 text-xs font-semibold text-gray-700 hover:bg-gray-50 disabled:opacity-60">
                      {baixando === c.usuarioId ? "Abrindo..." : "📎 Arquivo enviado pelo candidato"}</button>
                  : <span className="text-xs text-gray-400 py-1.5">Sem arquivo anexado</span>}
                <button type="button" onClick={() => setPerfilAberto(c)}
                  className="rounded-lg border border-primary/40 px-3 py-1.5 text-xs font-semibold text-primary hover:bg-primary/5">👤 Ver perfil completo</button>
                {/* Muita empresa responde pelo canal dela (e-mail próprio, ATS, telefone). Sem um jeito de
                    registrar isso, o eaiRH seguia cobrando quem já respondeu e, na expiração da vaga, avisava
                    o CANDIDATO de que ele ficou sem retorno — desmentindo a empresa na frente dele. */}
                {c.retornoEm
                  ? <span className="rounded-lg bg-green-50 text-green-800 px-3 py-1.5 text-xs font-semibold">
                      ✓ retorno dado{c.retornoForaDaPlataforma ? " (fora do eaiRH)" : ""} em {new Date(c.retornoEm).toLocaleDateString("pt-BR")}
                    </span>
                  : <button type="button" onClick={() => marcarRespondido(c.usuarioId)} disabled={marcando === c.usuarioId}
                      title="Use quando você já respondeu esta pessoa por e-mail, telefone ou pelo seu sistema. Não envia nada ao candidato."
                      className="rounded-lg border border-gray-300 px-3 py-1.5 text-xs font-semibold text-gray-700 hover:bg-gray-50 disabled:opacity-60">
                      {marcando === c.usuarioId ? "Registrando..." : "✓ Já respondi por fora"}</button>}
                {/* E-MAIL PELO PORTAL, não mailto. O mailto jogava o recrutador para fora: escrevia do zero, sem
                    modelo, o texto não ficava registrado aqui e o candidato não via o retorno na plataforma —
                    justamente o que a gente cobra das empresas. O form (mesmo do "Ver perfil completo") já tem
                    modelo por etapa, versão WhatsApp e assinatura. */}
                {c.email && <button type="button" onClick={() => setEmailPara(c)}
                  className="rounded-lg border border-gray-300 px-3 py-1.5 text-xs font-semibold text-gray-700 hover:bg-gray-50">✉️ Enviar e-mail</button>}
                {zap.length >= 10 && <a href={`https://wa.me/55${zap.length > 11 ? zap.slice(-11) : zap}`} target="_blank" rel="noreferrer"
                  className="rounded-lg border border-green-300 px-3 py-1.5 text-xs font-semibold text-green-700 hover:bg-green-50">💬 WhatsApp</a>}
              </div>
            </div>
          );
        })}
      </div>
      {perfilAberto && (
        <ModalCandidato c={perfilAberto} vaga={vaga} onFechar={() => setPerfilAberto(null)} />
      )}
      {emailPara && (
        <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/50 p-4 overflow-y-auto" onClick={() => setEmailPara(null)}>
          <div className="bg-background rounded-2xl shadow-2xl max-w-2xl w-full my-8 p-5" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <h3 className="font-bold text-gray-900 break-words">Enviar mensagem para {emailPara.nome}</h3>
                <p className="text-xs text-gray-500 mt-0.5">{emailPara.email} · vaga {vagaTitulo}</p>
              </div>
              <button onClick={() => setEmailPara(null)} aria-label="Fechar" className="text-gray-400 hover:text-gray-600 text-xl leading-none shrink-0">×</button>
            </div>
            <div className="mt-4">
              <FormRetorno vagaId={vagaId} usuarioId={emailPara.usuarioId} nome={emailPara.nome} vagaTitulo={vagaTitulo}
                empresaNome={vaga?.empresa} onPronto={() => setEmailPara(null)} />
            </div>
            <p className="mt-3 text-[11px] text-gray-500">
              A mensagem sai pelo eaiRH com a sua assinatura, fica registrada no processo e o candidato também a vê na plataforma.
            </p>
          </div>
        </div>
      )}
    </section>
  );
}

// Só "Disponível" e "Aberto a propostas" — quem está "Não buscando" NÃO aparece na busca da empresa (consentimento,
// filtrado no backend), então oferecer esse filtro retornaria sempre vazio.
const DISPONIB = ["Disponível", "Aberto a propostas"];
function dispCor(d) { return d === "Disponível" ? "text-green-700" : d === "Aberto a propostas" ? "text-blue-700" : "text-gray-400"; }

const MSG_ABORDAGEM_PADRAO = "Oi, {nome}! Vi seu perfil e achei que você combina demais com a vaga de {vaga} aqui na {empresa}. Se fizer sentido pra você, dá uma olhada e se candidata por aqui — vou adorar te conhecer no processo. 😊";

function Candidatos({ vaga }) {
  const vagaId = vaga.id;
  // Piso de 20%: sugerir supervisora pedagógica para vaga de Oracle não é achado, é ruído — e ruído no lugar
  // onde a empresa julga a plataforma custa credibilidade. A parceira levantou isso em 19/08, com razão.
  // Fica como filtro visível (não regra escondida): quem quiser ver tudo é só zerar o campo "match mín.".
  const [filtros, setFiltros] = useState({ senioridade: "", cidade: "", skill: "", matchMin: "20", disponibilidade: "" });
  const [lista, setLista] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [sel, setSel] = useState(() => new Set()); // usuarioIds marcados para abordar
  const [modalAbordar, setModalAbordar] = useState(false);
  const [perfilAberto, setPerfilAberto] = useState(null); // candidato no modal de perfil
  const reqSeq = useRef(0); // guard contra resposta fora de ordem ao trocar filtros rápido

  const carregar = useCallback(async (f) => {
    const seq = ++reqSeq.current;
    setCarregando(true);
    try { const data = await candidatosDaVaga(vagaId, f); if (seq === reqSeq.current) setLista(data); }
    catch { if (seq === reqSeq.current) setLista([]); }
    finally { if (seq === reqSeq.current) setCarregando(false); }
  }, [vagaId]);

  useEffect(() => { carregar(filtros); }, [carregar]); // eslint-disable-line react-hooks/exhaustive-deps
  const aplicar = (n) => { const f = { ...filtros, ...n }; setFiltros(f); carregar(f); };

  const toggle = (uid) => setSel((s) => { const n = new Set(s); if (n.has(uid)) n.delete(uid); else n.add(uid); return n; });
  const selecionados = lista.filter((c) => sel.has(c.usuarioId));

  const selCls = "rounded-lg border border-gray-300 px-2.5 py-1.5 text-sm outline-none focus:ring-2 focus:ring-primary";

  return (
    <section className="mt-6">
      {/* O título dizia "Candidatos compatíveis" — e para quem opera recrutamento "candidato" é quem SE
          CANDIDATOU. Em 19/08 a empresa parceira leu esta lista como os inscritos da vaga e conferiu 27 pessoas
          uma a uma no ATS dela; a maioria "não constava" porque nunca se candidatou a nada. O trabalho perdido
          foi culpa da nossa palavra, não do entendimento dela. Aqui o nome diz o que a lista é. */}
      <div className="flex flex-wrap items-center justify-between gap-2 mb-1">
        <h2 className="text-xl font-bold text-gray-900">Sugestões do banco de talentos</h2>
        {sel.size > 0 && (
          <button onClick={() => setModalAbordar(true)} className="rounded-xl bg-primary hover:bg-brand text-white font-semibold px-4 py-2 text-sm">
            ✉️ Abordar {sel.size} selecionado{sel.size > 1 ? "s" : ""}
          </button>
        )}
      </div>
      <p className="text-sm text-gray-500 mb-3">
        Estas pessoas <strong>não se candidataram</strong> a esta vaga — são perfis do banco de talentos que
        combinam com ela. Você pode convidá-las. Quem se candidatou aparece em <strong>Candidaturas recebidas</strong>, acima.
      </p>
      <div className="flex flex-wrap items-center gap-2 rounded-2xl border border-gray-200 bg-white p-3 shadow-sm mb-3">
        <span className="text-sm font-semibold text-gray-600">Filtros:</span>
        <select className={selCls} aria-label="Filtrar por senioridade" value={filtros.senioridade} onChange={(e) => aplicar({ senioridade: e.target.value })}>
          <option value="">Senioridade</option>{SENIORIDADES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        <input className={selCls} placeholder="Cidade" aria-label="Filtrar por cidade" value={filtros.cidade} onChange={(e) => setFiltros({ ...filtros, cidade: e.target.value })} onKeyDown={(e) => e.key === "Enter" && aplicar({})} />
        <input className={selCls} placeholder="Skill" aria-label="Filtrar por skill" value={filtros.skill} onChange={(e) => setFiltros({ ...filtros, skill: e.target.value })} onKeyDown={(e) => e.key === "Enter" && aplicar({})} />
        <input type="number" min="0" max="100" step="5" className={selCls} aria-label="Match mínimo (%)" placeholder="Match mín. (%)"
          value={filtros.matchMin} onChange={(e) => setFiltros({ ...filtros, matchMin: e.target.value })} onKeyDown={(e) => e.key === "Enter" && aplicar({})} />
        <select className={selCls} aria-label="Filtrar por disponibilidade" value={filtros.disponibilidade} onChange={(e) => aplicar({ disponibilidade: e.target.value })}>
          <option value="">Disponibilidade</option>{DISPONIB.map((d) => <option key={d} value={d}>{d}</option>)}
        </select>
      </div>

      <div className="overflow-x-auto rounded-2xl border border-gray-200 bg-white shadow-sm">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-gray-500 text-xs uppercase">
            <tr>
              <th className="px-4 py-3 w-8"></th>
              <th className="text-left px-4 py-3">Match</th>
              <th className="text-left px-4 py-3">Nome</th>
              <th className="text-left px-4 py-3">Senioridade</th>
              <th className="text-left px-4 py-3">Anos exp.</th>
              <th className="text-left px-4 py-3">Cidade</th>
              <th className="text-left px-4 py-3">Disponib.</th>
              <th className="text-left px-4 py-3">Skills</th>
              <th className="text-left px-4 py-3">Retorno</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {carregando && <tr><td colSpan="8" className="px-4 py-6 text-gray-400">Carregando...</td></tr>}
            {!carregando && lista.length === 0 && <tr><td colSpan="8" className="px-4 py-6 text-gray-400">Nenhum candidato compatível ainda.</td></tr>}
            {!carregando && lista.map((c) => (
              <React.Fragment key={c.usuarioId}>
                <tr className="hover:bg-gray-50">
                  <td className="px-4 py-3"><input type="checkbox" aria-label={`Selecionar ${c.nome} para abordagem`} checked={sel.has(c.usuarioId)} onChange={() => toggle(c.usuarioId)} /></td>
                  <td className="px-4 py-3"><span className={`font-bold rounded-full px-2.5 py-1 text-xs ${corMatch(c.match)}`}>{c.match}%</span></td>
                  <td className="px-4 py-3 font-semibold text-gray-900"><button onClick={() => setPerfilAberto(c)} className="text-left hover:underline text-primary" title="Ver o perfil completo, currículo e dar retorno">{c.nome}</button>{c.temCurriculo && <span className="ml-1 text-xs text-gray-400" title="tem CV em PDF">📎</span>}{c.jaAbordado && <span className="ml-1.5 align-middle text-[10px] rounded-full bg-blue-50 text-blue-700 px-1.5 py-0.5 font-semibold" title="Você já abordou este candidato nesta vaga">já abordado</span>}<div className="text-xs font-normal text-gray-500">{c.headline}</div></td>
                  <td className="px-4 py-3 text-gray-600">{c.senioridade || "—"}</td>
                  <td className="px-4 py-3 text-gray-600">{c.anosExperiencia || "—"}</td>
                  <td className="px-4 py-3 text-gray-600">{c.cidade || "—"}</td>
                  <td className={`px-4 py-3 text-xs font-semibold ${dispCor(c.disponibilidade)}`}>{c.disponibilidade}</td>
                  <td className="px-4 py-3 text-gray-600">{c.skills.slice(0, 4).join(", ")}{c.skills.length > 4 ? "…" : ""}</td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      {perfilAberto && (
        <ModalCandidato c={perfilAberto} vaga={vaga} onFechar={() => setPerfilAberto(null)}
          onRetornoEnviado={() => { setPerfilAberto(null); carregar(filtros); }} />
      )}
      {modalAbordar && (
        <AbordarModal vaga={vaga} candidatos={selecionados}
          onFechar={() => setModalAbordar(false)}
          onEnviado={() => { setModalAbordar(false); setSel(new Set()); carregar(filtros); }} />
      )}
    </section>
  );
}

// Modal de abordagem ativa: convida os candidatos selecionados à vaga por e-mail/WhatsApp, com mensagem
// parametrizável. O backend anexa o link da vaga + a assinatura do recrutador e respeita o opt-in do candidato.
function AbordarModal({ vaga, candidatos, onFechar, onEnviado }) {
  const [mensagem, setMensagem] = useState(MSG_ABORDAGEM_PADRAO);
  const [porEmail, setPorEmail] = useState(true);
  const [porWhatsapp, setPorWhatsapp] = useState(true);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState(null);
  const [ok, setOk] = useState(null);

  const enviar = async () => {
    if (enviando) return;
    if (!porEmail && !porWhatsapp) { setErro("Escolha ao menos um canal (e-mail ou WhatsApp)."); return; }
    if (!mensagem.trim()) { setErro("Escreva a mensagem de abordagem."); return; }
    setErro(null); setEnviando(true);
    try {
      const r = await abordarCandidatos(vaga.id, { usuarioIds: candidatos.map((c) => c.usuarioId), mensagem, porEmail, porWhatsapp });
      setOk(`Abordagem enviada a ${r.enviados} candidato(s)${r.pulados ? ` · ${r.pulados} pulado(s) (indisponível)` : ""}.`);
      setTimeout(onEnviado, 2000);
    } catch (e) { setErro(e.message); setEnviando(false); }
  };

  const ta = "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary";
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/50 p-4 overflow-y-auto" onClick={onFechar}>
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full my-8 p-5" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-lg font-bold text-gray-900">Abordar {candidatos.length} candidato{candidatos.length > 1 ? "s" : ""}</h3>
          <button onClick={onFechar} aria-label="Fechar" className="text-gray-400 hover:text-gray-700 text-2xl leading-none">×</button>
        </div>
        <p className="text-xs text-gray-500 mb-3">Convide para a vaga <strong>{vaga.titulo}</strong>. Anexamos o link da vaga + sua assinatura, e o contato do candidato fica protegido — o eaiRH intermedia.</p>

        <label className="block text-sm">
          <span className="font-semibold text-gray-700">Mensagem</span>
          <textarea value={mensagem} onChange={(e) => setMensagem(e.target.value)} rows={5} className={ta + " mt-1"} />
        </label>
        <p className="text-[11px] text-gray-400 mt-1">Use <code className="bg-gray-100 px-1 rounded">{"{nome}"}</code>, <code className="bg-gray-100 px-1 rounded">{"{vaga}"}</code> e <code className="bg-gray-100 px-1 rounded">{"{empresa}"}</code> — trocamos pelos dados reais de cada candidato.</p>

        <div className="flex flex-wrap items-center gap-4 text-sm mt-3">
          <span className="font-semibold text-gray-700">Enviar por:</span>
          <label className="flex items-center gap-1.5"><input type="checkbox" checked={porEmail} onChange={(e) => setPorEmail(e.target.checked)} /> E-mail</label>
          <label className="flex items-center gap-1.5"><input type="checkbox" checked={porWhatsapp} onChange={(e) => setPorWhatsapp(e.target.checked)} /> WhatsApp</label>
          <span className="text-[11px] text-gray-400">(só chega em quem autorizou o canal)</span>
        </div>

        {erro && <p role="alert" className="text-red-600 text-sm mt-2">{erro}</p>}
        {ok && <p role="status" className="text-green-700 text-sm font-semibold mt-2">{ok}</p>}

        <div className="flex gap-2 mt-4">
          <button onClick={enviar} disabled={enviando || !!ok} className="rounded-xl bg-primary hover:bg-brand disabled:opacity-60 text-white font-semibold px-5 py-2 text-sm">{enviando ? "Enviando..." : "Enviar abordagem"}</button>
          {!ok && <button onClick={onFechar} className="rounded-xl border border-gray-300 text-gray-600 font-semibold px-4 py-2 text-sm hover:bg-gray-50">Cancelar</button>}
        </div>
      </div>
    </div>
  );
}

// Modal da empresa, aberto pelo logo da vaga. O candidato decide se vale se candidatar OLHANDO A REPUTAÇÃO —
// e obrigá-lo a sair da vaga para descobrir isso é perder a decisão no meio do caminho. Aqui ele vê o essencial
// (reputação, resposta, tempo de retorno, alertas) sem perder a vaga de vista, com a página completa a um clique.
function ModalEmpresa({ vaga, onFechar }) {
  const navigate = useNavigate();
  const [e, setE] = useState(null);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    obterEmpresa(vaga.empresaId).then((r) => setE(r.empresa)).catch((x) => setErro(x.message));
  }, [vaga.empresaId]);

  const pct = (n) => n == null ? null : `${Math.round(Number(n))}%`;

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-start justify-center overflow-y-auto p-4" onClick={onFechar}>
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-2xl my-8" onClick={(ev) => ev.stopPropagation()}>
        <div className="flex items-start justify-between gap-3 p-5 border-b border-gray-200">
          <div className="flex items-center gap-3">
            {vaga.empresaTemLogo && <img src={empresaLogoUrl(vaga.empresaId)} alt={vaga.empresa} className="h-12 w-12 rounded-lg object-contain border border-gray-200 bg-white" />}
            <div>
              <h3 className="text-xl font-bold text-gray-900">{vaga.empresa}{vaga.empresaVerificada && <span className="ml-1 text-blue-600">✔</span>}</h3>
              <p className="text-xs text-gray-500">{[e?.setor, e?.cidade, vaga.empresaPorte && `${vaga.empresaPorte} porte`].filter(Boolean).join(" · ") || "—"}</p>
            </div>
          </div>
          <button onClick={onFechar} aria-label="Fechar" className="text-gray-400 hover:text-gray-700 text-2xl leading-none">×</button>
        </div>

        <div className="p-5 space-y-5">
          {erro && <p role="alert" className="text-red-600 text-sm">{erro}</p>}
          {!e && !erro && <p className="text-gray-500 text-sm">Carregando...</p>}

          {e && (
            <>
              <div className="flex items-center gap-3 flex-wrap">
                {(() => {
                  const r = reputacaoDaEmpresa(e.score, vaga.empresaSelo, e.classificacao);
                  return (
                    <>
                      <span className={`inline-block rounded-full px-3 py-1 text-sm font-bold ${r.cor}`} title={r.titulo}>
                        {r.nota ? `reputação ${r.nota}` : "sem avaliações"}
                      </span>
                      <span className="text-sm text-gray-600">{r.nota ? e.classificacao : "nenhum candidato avaliou esta empresa ainda"}</span>
                    </>
                  );
                })()}
              </div>

              {vaga.empresaAlertas?.length > 0 && (
                <div className="rounded-lg bg-amber-50 border border-amber-200 text-amber-800 text-xs px-3 py-2">
                  {vaga.empresaAlertas.join(" · ")}
                </div>
              )}

              <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-3 text-sm">
                <Dado rotulo="Relatos">{e.totalDenuncias > 0 ? `${e.totalDenuncias}` : "nenhum"}</Dado>
                <Dado rotulo="Responde aos relatos">{e.totalDenuncias > 0 ? pct(e.indiceResposta) : null}</Dado>
                <Dado rotulo="Resolve">{e.totalDenuncias > 0 ? pct(e.indiceSolucao) : null}</Dado>
                <Dado rotulo="Voltaria a se candidatar">{e.totalDenuncias > 0 ? pct(e.indiceVoltaria) : null}</Dado>
                <Dado rotulo="Nota média">{e.totalDenuncias > 0 ? Number(e.notaMedia || 0).toFixed(1) : null}</Dado>
                <Dado rotulo="Tempo médio de resposta">{e.tempoMedioRespostaHoras != null ? `${Math.round(e.tempoMedioRespostaHoras)}h` : null}</Dado>
                <Dado rotulo="Retorno ao candidato">{e.tempoMedioRetornoDias != null ? `${Math.round(e.tempoMedioRetornoDias)} dias` : null}</Dado>
                <Dado rotulo="Elogios">{e.totalElogios > 0 ? `${e.totalElogios}` : null}</Dado>
              </div>

              {e.certificacoes?.length > 0 && (
                <div>
                  <div className="text-[11px] uppercase tracking-wide text-gray-500 font-semibold mb-1.5">Certificações <span className="normal-case font-normal">(informadas pela empresa)</span></div>
                  <div className="flex flex-wrap gap-1.5">{e.certificacoes.map((c) => <Chip key={c}>{c}</Chip>)}</div>
                </div>
              )}

              {e.sobre && (
                <div>
                  <div className="text-[11px] uppercase tracking-wide text-gray-500 font-semibold mb-1">Sobre</div>
                  <p className="text-sm text-gray-700 whitespace-pre-line">{e.sobre}</p>
                </div>
              )}

              <div className="flex flex-wrap gap-2 pt-1">
                <button onClick={() => navigate(`/empresas/${vaga.empresaId}`)}
                  className="rounded-xl bg-primary hover:bg-brand text-white text-sm font-semibold px-4 py-2">
                  Ver a página da empresa e os relatos
                </button>
                <button onClick={onFechar} className="rounded-xl border border-gray-300 hover:bg-gray-50 text-sm font-semibold px-4 py-2">
                  Voltar para a vaga
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// Modal do candidato: tudo o que a empresa precisa para decidir, sem sair da lista — perfil completo,
// currículo e o retorno na mesma tela. O contato (e-mail/telefone) NÃO aparece de propósito: a conversa passa
// pelo eaiRH, que é o que permite cobrar o retorno depois e não deixar o candidato no vácuo.
function ModalCandidato({ c, vaga, onFechar, onRetornoEnviado }) {
  const [p, setP] = useState(null);
  const [erro, setErro] = useState(null);
  const [baixando, setBaixando] = useState(false);

  useEffect(() => {
    obterPerfilPublico(c.usuarioId).then(setP).catch((e) => setErro(e.message));
  }, [c.usuarioId]);

  const abrirCv = async () => {
    setErro(null); setBaixando(true);
    try { await baixarCurriculoCandidato(c.usuarioId); }
    catch (e) { setErro(e.message); }
    finally { setBaixando(false); }
  };

  const dinheiro = (v) => v == null ? null : `R$ ${Number(v).toLocaleString("pt-BR", { maximumFractionDigits: 0 })}`;

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-start justify-center overflow-y-auto p-4" onClick={onFechar}>
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-3xl my-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-3 p-5 border-b border-gray-200">
          <div>
            <div className="flex items-center gap-2 flex-wrap">
              <h3 className="text-xl font-bold text-gray-900">{c.nome}</h3>
              <span className={`font-bold rounded-full px-2.5 py-1 text-xs ${corMatch(c.match)}`}>{c.match}% de match</span>
              {c.jaAbordado && <span className="text-[11px] rounded-full bg-blue-50 text-blue-700 px-2 py-0.5 font-semibold">já abordado nesta vaga</span>}
            </div>
            {c.headline && <p className="text-sm text-gray-600 mt-0.5">{c.headline}</p>}
            {c.motivos?.length > 0 && (
              <p className="text-xs text-gray-500 mt-1">Por que deu match: {c.motivos.join(" · ")}</p>
            )}
          </div>
          <button onClick={onFechar} aria-label="Fechar" className="text-gray-400 hover:text-gray-700 text-2xl leading-none">×</button>
        </div>

        <div className="p-5 space-y-5">
          {erro && <p role="alert" className="text-red-600 text-sm">{erro}</p>}
          {!p && !erro && <p className="text-gray-500 text-sm">Carregando perfil...</p>}

          {p && (
            <>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-3 text-sm">
                <Dado rotulo="Senioridade">{p.senioridade}</Dado>
                <Dado rotulo="Área">{p.areaAtuacao}</Dado>
                <Dado rotulo="Cidade">{p.cidade}</Dado>
                <Dado rotulo="Disponibilidade">{p.disponibilidadeTexto}</Dado>
                <Dado rotulo="Anos de experiência">{c.anosExperiencia || null}</Dado>
                <Dado rotulo="Aceita">{[...(p.modalidadesAceitas || []), ...(p.contratacoesAceitas || [])].join(", ") || null}</Dado>
                <Dado rotulo="Pretensão CLT">{dinheiro(p.pretensaoClt)}</Dado>
                <Dado rotulo="Pretensão PJ">{dinheiro(p.pretensaoPj)}</Dado>
              </div>

              {p.resumo && <div><div className="text-[11px] uppercase tracking-wide text-gray-500 font-semibold mb-1">Resumo</div>
                <p className="text-sm text-gray-700 whitespace-pre-line">{p.resumo}</p></div>}

              {p.skills?.length > 0 && (
                <div>
                  <div className="text-[11px] uppercase tracking-wide text-gray-500 font-semibold mb-1.5">Skills ({p.skills.length})</div>
                  <div className="flex flex-wrap gap-1.5">
                    {p.skills.map((s) => {
                      const pedida = (vaga.skills || []).some((x) => x.toLowerCase() === s.toLowerCase());
                      return <span key={s} title={pedida ? "Esta skill é pedida na vaga" : undefined}
                        className={`rounded-full px-2.5 py-1 text-xs font-semibold ${pedida ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-700"}`}>{pedida && "✓ "}{s}</span>;
                    })}
                  </div>
                </div>
              )}

              {p.experiencias?.length > 0 && (
                <div>
                  <div className="text-[11px] uppercase tracking-wide text-gray-500 font-semibold mb-1.5">Experiência</div>
                  <ul className="space-y-2">
                    {p.experiencias.map((e, i) => (
                      <li key={i} className="text-sm">
                        <span className="font-semibold text-gray-900">{e.cargo}</span>
                        <span className="text-gray-600"> · {e.empresa}</span>
                        {e.periodo && <span className="text-gray-400 text-xs"> ({e.periodo})</span>}
                        {e.descricao && <p className="text-gray-600 text-xs mt-0.5 whitespace-pre-line">{e.descricao}</p>}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {p.formacoes?.length > 0 && (
                <div>
                  <div className="text-[11px] uppercase tracking-wide text-gray-500 font-semibold mb-1.5">Formação</div>
                  <ul className="space-y-1">
                    {p.formacoes.map((f, i) => (
                      <li key={i} className="text-sm text-gray-700">{f.curso} · <span className="text-gray-600">{f.instituicao}</span>
                        {f.periodo && <span className="text-gray-400 text-xs"> ({f.periodo})</span>}</li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="flex flex-wrap gap-2 pt-1">
                <button onClick={abrirCv} disabled={!p.temCurriculo || baixando}
                  className="rounded-xl bg-gray-900 hover:bg-black disabled:opacity-40 text-white text-sm font-semibold px-4 py-2">
                  📄 {baixando ? "Abrindo..." : p.temCurriculo ? "Abrir currículo" : "Sem currículo anexado"}
                </button>
                {p.linkedinUrl && (
                  <a href={p.linkedinUrl} target="_blank" rel="noopener noreferrer"
                    className="rounded-xl border border-gray-300 hover:bg-gray-50 text-sm font-semibold px-4 py-2">LinkedIn</a>
                )}
              </div>
            </>
          )}

          <div className="pt-2 border-t border-gray-200">
            <div className="text-[11px] uppercase tracking-wide text-gray-500 font-semibold mb-2">Dar retorno sobre esta vaga</div>
            <FormRetorno vagaId={vaga.id} usuarioId={c.usuarioId} nome={c.nome} vagaTitulo={vaga.titulo}
              empresaNome={vaga.empresa} onPronto={onRetornoEnviado} />
          </div>
        </div>
      </div>
    </div>
  );
}

// Mensagens PRONTAS por status — o recrutador só ajusta. Com campo em branco, o retorno vira "não selecionado"
// e ponto; o candidato recebe um carimbo. Aqui ele recebe um recado escrito como gente fala, com o nome dele.
const RETORNO_PADRAO = {
  "Currículo recebido": {
    html: "<p>Oi, {nome}! 👋</p><p>Recebemos seu currículo para a vaga de <b>{vaga}</b> aqui na <b>{empresa}</b> — obrigado pelo interesse!</p><p>Vamos analisar com calma e te damos retorno por aqui, seguindo ou não. 🙌</p>",
    wpp: "Oi, {nome}! 👋\n\nRecebemos seu currículo para a vaga de *{vaga}* na *{empresa}* — obrigado pelo interesse!\n\nVamos analisar com calma e te damos retorno por aqui, seguindo ou não. 🙌",
  },
  "Convidado para entrevista": {
    html: "<p>Oi, {nome}! 🎉</p><p>Gostamos muito do seu perfil para a vaga de <b>{vaga}</b> na <b>{empresa}</b> e queremos te conhecer melhor.</p><p>Vamos combinar uma conversa? Responda por aqui com os melhores dias e horários para você. 📅</p>",
    wpp: "Oi, {nome}! 🎉\n\nGostamos muito do seu perfil para a vaga de *{vaga}* na *{empresa}* e queremos te conhecer melhor.\n\nVamos combinar uma conversa? Me responda com os melhores dias e horários para você. 📅",
  },
  "Em análise": {
    html: "<p>Oi, {nome}!</p><p>Seu perfil para a vaga de <b>{vaga}</b> na <b>{empresa}</b> está <b>em análise</b> com o time responsável. ⏳</p><p>Assim que tivermos uma definição, você é avisado por aqui — sem sumiço.</p>",
    wpp: "Oi, {nome}!\n\nSeu perfil para a vaga de *{vaga}* na *{empresa}* está _em análise_ com o time responsável. ⏳\n\nAssim que tivermos uma definição, te aviso por aqui — sem sumiço.",
  },
  "Avançou de etapa": {
    html: "<p>Boa notícia, {nome}! ✅</p><p>Você <b>avançou de etapa</b> no processo da vaga de <b>{vaga}</b> na <b>{empresa}</b>.</p><p>Em breve mandamos os detalhes do próximo passo por aqui.</p>",
    wpp: "Boa notícia, {nome}! ✅\n\nVocê *avançou de etapa* no processo da vaga de *{vaga}* na *{empresa}*.\n\nEm breve mando os detalhes do próximo passo.",
  },
  "Não selecionado desta vez": {
    html: "<p>Oi, {nome}!</p><p>Obrigado por participar do processo da vaga de <b>{vaga}</b> na <b>{empresa}</b>. Dessa vez seguimos com outro perfil. 🙏</p><p>Isso não diz nada sobre o seu valor profissional — foi só o encaixe deste processo específico. Seu currículo fica com a gente para as próximas oportunidades.</p><p>Boa sorte, de verdade!</p>",
    wpp: "Oi, {nome}!\n\nObrigado por participar do processo da vaga de *{vaga}* na *{empresa}*. Dessa vez seguimos com outro perfil. 🙏\n\nIsso não diz nada sobre o seu valor profissional — foi só o encaixe deste processo. Seu currículo fica com a gente para as próximas.\n\nBoa sorte, de verdade!",
  },
};

function FormRetorno({ vagaId, usuarioId, nome, onPronto, vagaTitulo, empresaNome }) {
  const [status, setStatus] = useState(RETORNOS_VAGA[1]);
  const [mensagem, setMensagem] = useState("");
  const [mensagemWpp, setMensagemWpp] = useState("");
  const [rev, setRev] = useState(0);   // força o editor visual a recarregar quando trocamos o texto por fora
  const [msg, setMsg] = useState(null);
  const [erro, setErro] = useState(null);
  const [enviando, setEnviando] = useState(false);
  // Modelos que a empresa já escreveu (os mesmos do encerramento). Reescrever a mesma mensagem a cada
  // candidato é o que faz o recrutador desistir de responder — e o silêncio é o problema que o eaiRH ataca.
  const [modelos, setModelos] = useState([]);
  const [porEmail, setPorEmail] = useState(true);
  const [porWhatsapp, setPorWhatsapp] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const recarregarModelos = () => modelosEncerramento().then((r) => setModelos(r || [])).catch(() => {});
  useEffect(() => { recarregarModelos(); }, []);

  // Ao escolher o status, já entra a mensagem pronta daquele momento do processo (com as tags resolvidas para
  // este candidato). O recrutador edita se quiser — mas nunca fica com a tela em branco.
  const preencherPadrao = (novoStatus) => {
    const m = RETORNO_PADRAO[novoStatus];
    if (!m) return;
    const tags = (t) => t.replace(/\{nome\}/g, (nome || "").split(" ")[0] || "")
                         .replace(/\{vaga\}/g, vagaTitulo || "").replace(/\{empresa\}/g, empresaNome || "");
    setMensagem(tags(m.html));
    setMensagemWpp(tags(m.wpp));
    setRev((r) => r + 1);
  };
  useEffect(() => { preencherPadrao(status); }, []);   // eslint-disable-line react-hooks/exhaustive-deps

  // Salvar como modelo DA EMPRESA: a mensagem que ela acabou de escrever vira reutilizável, com as tags
  // no lugar dos dados deste candidato — senão o modelo sairia com o nome de uma pessoa só dentro.
  const salvarComoModelo = async () => {
    const texto = mensagem.trim();
    if (!texto) { setErro('Escreva a mensagem antes de salvar como modelo.'); return; }
    const sugerido = window.prompt('Nome do modelo (ex.: "Convite para entrevista")', status);
    if (!sugerido) return;
    const comTags = texto
      .replace(new RegExp(nome || '\u0000', 'g'), '{nome}')
      .replace(new RegExp(vagaTitulo || '\u0000', 'g'), '{vaga}')
      .replace(new RegExp(empresaNome || '\u0000', 'g'), '{empresa}');
    setSalvando(true); setErro(null);
    try {
      await criarModeloEncerramento({ tipo: status.toLowerCase().includes('não selecionado') ? 1 : 0,
        nome: sugerido.trim().slice(0, 120), corpo: comTags, corpoWhatsapp: comTags, padrao: false });
      await recarregarModelos();
      setMsg('Modelo salvo — já aparece na lista para os próximos candidatos.');
    } catch (e) { setErro(e.message); }
    finally { setSalvando(false); }
  };

  const aplicarModelo = (id) => {
    const m = modelos.find((x) => String(x.id) === String(id));
    if (!m) return;
    // Do modelo de e-mail (HTML) só interessa o texto aqui: este campo é uma linha simples.
    const tags = (t) => (t || "").replace(/\{nome\}/g, (nome || "").split(" ")[0] || "")
                                 .replace(/\{vaga\}/g, vagaTitulo || "").replace(/\{empresa\}/g, empresaNome || "");
    setMensagem(tags(m.corpo || ""));
    setMensagemWpp(tags(m.corpoWhatsapp || (m.corpo || "").replace(/<[^>]+>/g, "")));
    setRev((r) => r + 1);
  };

  const enviar = async () => {
    if (enviando) return; // anti-duplo-clique: darRetorno não tem dedup no backend; evita 2 notificações ao candidato
    setErro(null); setEnviando(true);
    try {
      const r = await darRetornoVaga(vagaId, usuarioId, status, mensagem, { porEmail, porWhatsapp, mensagemWhatsapp: mensagemWpp });
      const canais = ["sino interno", r.viaEmail && "e-mail", r.viaWhatsapp && "WhatsApp"].filter(Boolean).join(", ");
      setMsg(`Retorno enviado para ${nome} via ${canais} — sem expor o contato dele(a).`);
      setTimeout(onPronto, 1500);
    } catch (e) { setErro(e.message); setEnviando(false); }
  };

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-3">
      {msg && <p role="status" className="text-green-700 text-sm mb-2">{msg}</p>}
      {erro && <p role="alert" className="text-red-600 text-sm mb-2">{erro}</p>}
      <div className="flex flex-wrap gap-2 items-center">
        <select aria-label="Status do retorno" value={status} onChange={(e) => { setStatus(e.target.value); preencherPadrao(e.target.value); }} className="rounded-lg border border-gray-300 px-2.5 py-1.5 text-sm">
          {RETORNOS_VAGA.map((r) => <option key={r} value={r}>{r}</option>)}
        </select>
        {modelos.length > 0 && (
          <select aria-label="Usar um modelo de mensagem" defaultValue="" onChange={(e) => aplicarModelo(e.target.value)}
            className="rounded-lg border border-gray-300 px-2.5 py-1.5 text-sm text-gray-700">
            <option value="">📄 Usar modelo…</option>
            {modelos.map((m) => <option key={m.id} value={m.id}>{m.nome}</option>)}
          </select>
        )}

        <button onClick={enviar} disabled={enviando} className="rounded-lg bg-primary hover:bg-brand disabled:opacity-60 text-white text-sm font-semibold px-4 py-1.5">{enviando ? "Enviando..." : "Enviar retorno"}</button>
      </div>

      {/* Dois corpos, como nos modelos de encerramento: e-mail aceita formatação e o WhatsApp usa os marcadores
          nativos. Mandar HTML no WhatsApp entrega tag na tela do candidato. */}
      <div className="mt-3 grid grid-cols-1 lg:grid-cols-2 gap-3">
        <div>
          <div className="text-[11px] uppercase tracking-wide text-gray-500 font-semibold mb-1">✉️ Mensagem por e-mail</div>
          <HtmlEditor key={`ret-${rev}`} initialHtml={mensagem} onChange={setMensagem} tags={TAGS_ENCERRAMENTO} />
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-wide text-gray-500 font-semibold mb-1">📲 Mensagem por WhatsApp</div>
          <WhatsappEditor value={mensagemWpp} onChange={setMensagemWpp} tags={TAGS_ENCERRAMENTO} rows={8}
            placeholder="Oi, {nome}! ..." />
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-3 mt-2">
        <label className="flex items-center gap-1.5 text-xs text-gray-600">
          <input type="checkbox" checked={porEmail} onChange={(e) => setPorEmail(e.target.checked)} /> E-mail
        </label>
        <label className="flex items-center gap-1.5 text-xs text-gray-600">
          <input type="checkbox" checked={porWhatsapp} onChange={(e) => setPorWhatsapp(e.target.checked)} /> WhatsApp
        </label>
        <button type="button" onClick={salvarComoModelo} disabled={salvando}
          className="text-xs font-semibold text-primary hover:underline disabled:opacity-50">
          {salvando ? "Salvando..." : "💾 Salvar esta mensagem como modelo"}
        </button>
      </div>
      <p className="text-[11px] text-gray-400 mt-1">O aviso no sino interno sai sempre (é o registro do retorno). E-mail e WhatsApp respeitam também a preferência do candidato.</p>
    </div>
  );
}

function Tela({ children }) {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-5xl mx-auto px-4 md:px-6 py-8 pb-28 md:pb-8">{children}</main>
    </div>
  );
}
/**
 * Esconde a sigla curta que já aparece dentro de um termo maior da MESMA lista: com "Power BI" presente,
 * o "BI" solto é ruído visual. Só sigla (≤4 letras, tudo maiúsculo) e só quando é o FIM do outro termo —
 * "SQL" continua visível ao lado de "PL/SQL" e de "MySQL", que são outra coisa.
 */
function semSiglaRedundante(lista) {
  const itens = lista || [];
  return itens.filter((n) => {
    const sigla = n.length <= 4 && /[A-Za-z]/.test(n) && n === n.toUpperCase();
    if (!sigla) return true;
    return !itens.some((o) => o !== n && o.length > n.length && o.toUpperCase().endsWith(" " + n.toUpperCase()));
  });
}

function Chip({ children, azul, tem, falta }) {
  // `tem` e `falta` só chegam preenchidos quando há currículo para comparar. O ✓ e o + não são enfeite:
  // cor sozinha exclui quem não distingue verde de vermelho — e a maior parte do nosso público entra
  // pelo navegador de dentro do LinkedIn, numa tela pequena.
  const estilo = tem ? "bg-green-100 text-green-800 ring-1 ring-green-300"
    : falta ? "bg-red-50 text-red-700 ring-1 ring-red-300"
    : azul ? "bg-blue-100 text-blue-800"
    : "bg-gray-100 text-gray-700";
  return (
    <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${estilo}`}>
      {tem && <span aria-hidden="true">✓ </span>}
      {falta && <span aria-hidden="true">+ </span>}
      {children}
      {tem && <span className="sr-only"> (você tem esta skill)</span>}
      {falta && <span className="sr-only"> (esta skill falta no seu currículo)</span>}
    </span>
  );
}

// Campo da ficha da vaga. Campo vazio aparece como "não informado" em cinza, e não some: o candidato precisa
// saber que a empresa NÃO disse a cidade — some é diferente de "não informado", e a diferença muda a decisão.
function Dado({ rotulo, children }) {
  return (
    <div>
      <div className="text-[11px] uppercase tracking-wide text-gray-500 font-semibold">{rotulo}</div>
      <div className={`mt-0.5 ${children ? "text-gray-900" : "text-gray-400 italic"}`}>{children || "não informado"}</div>
    </div>
  );
}
